// biome-ignore-all lint: generated

// biome-ignore-all assist: generated

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as _authRouteImport } from './routes/__auth'
import { Route as SignInRouteRouteImport } from './routes/sign-in/route'
import { Route as UserProfileIndexRouteImport } from './routes/user-profile/index'
import { Route as _authIndexRouteImport } from './routes/__auth/index'
import { Route as UserProfileChar123SuffixChar125RouteImport } from './routes/user-profile/{-$suffix}'
import { Route as SignInSplatRouteImport } from './routes/sign-in/$'
import { Route as _authYieldhubSyncRouteImport } from './routes/__auth/yieldhub-sync'
import { Route as _authUnitPricesRouteImport } from './routes/__auth/unit-prices'
import { Route as _authTransfersRouteImport } from './routes/__auth/transfers'
import { Route as _authTransferGroupsRouteImport } from './routes/__auth/transfer-groups'
import { Route as _authTransactionsRouteImport } from './routes/__auth/transactions'
import { Route as _authTransactionMonitoringRouteImport } from './routes/__auth/transaction-monitoring'
import { Route as _authTransactionImportRouteImport } from './routes/__auth/transaction-import'
import { Route as _authTermDepositsRouteImport } from './routes/__auth/term-deposits'
import { Route as _authStripePayoutQueueRouteImport } from './routes/__auth/stripe-payout-queue'
import { Route as _authStatementsRouteImport } from './routes/__auth/statements'
import { Route as _authScheduledFundMovementsRouteImport } from './routes/__auth/scheduled-fund-movements'
import { Route as _authProvidersRouteImport } from './routes/__auth/providers'
import { Route as _authProductsRouteImport } from './routes/__auth/products'
import { Route as _authPlaygroundRouteImport } from './routes/__auth/playground'
import { Route as _authOrganisationsRouteImport } from './routes/__auth/organisations'
import { Route as _authOnboardingRequestsRouteImport } from './routes/__auth/onboarding-requests'
import { Route as _authNonProcessingDaysRouteImport } from './routes/__auth/non-processing-days'
import { Route as _authMfaTestRouteImport } from './routes/__auth/mfa-test'
import { Route as _authLogosRouteImport } from './routes/__auth/logos'
import { Route as _authKycQueueRouteImport } from './routes/__auth/kyc-queue'
import { Route as _authJobsRouteImport } from './routes/__auth/jobs'
import { Route as _authHighRiskJurisdictionsRouteImport } from './routes/__auth/high-risk-jurisdictions'
import { Route as _authFxTradesRouteImport } from './routes/__auth/fx-trades'
import { Route as _authFundDistributionsRouteImport } from './routes/__auth/fund-distributions'
import { Route as _authFeatureFlagsRouteImport } from './routes/__auth/feature-flags'
import { Route as _authExternalProvidersRouteImport } from './routes/__auth/external-providers'
import { Route as _authEventsRouteImport } from './routes/__auth/events'
import { Route as _authEburyRouteImport } from './routes/__auth/ebury'
import { Route as _authDesignRouteImport } from './routes/__auth/design'
import { Route as _authDepositsRouteImport } from './routes/__auth/deposits'
import { Route as _authCustodyAccountsRouteImport } from './routes/__auth/custody-accounts'
import { Route as _authCurrencycloudRouteImport } from './routes/__auth/currencycloud'
import { Route as _authCronRouteImport } from './routes/__auth/cron'
import { Route as _authCashflowReportsRouteImport } from './routes/__auth/cashflow-reports'
import { Route as _authCashManagementStrategiesRouteImport } from './routes/__auth/cash-management-strategies'
import { Route as _authCalastoneOrdersRouteImport } from './routes/__auth/calastone-orders'
import { Route as _authBeneficiaryAccountsRouteImport } from './routes/__auth/beneficiary-accounts'
import { Route as _authAssetsRouteImport } from './routes/__auth/assets'
import { Route as _authAssetRulesRouteImport } from './routes/__auth/asset-rules'
import { Route as _authAdminRouteImport } from './routes/__auth/admin'
import { Route as _authSplatRouteImport } from './routes/__auth/$'
import { Route as _authEburyIndexRouteImport } from './routes/__auth/ebury.index'
import { Route as _authCurrencycloudIndexRouteImport } from './routes/__auth/currencycloud.index'
import { Route as _authYieldhubSyncFileIdRouteImport } from './routes/__auth/yieldhub-sync_.$fileId'
import { Route as _authTransfersNewRouteImport } from './routes/__auth/transfers_.new'
import { Route as _authTransfersTransferIdRouteImport } from './routes/__auth/transfers_.$transferId'
import { Route as _authTransferGroupsTransferGroupIdRouteImport } from './routes/__auth/transfer-groups_.$transferGroupId'
import { Route as _authTransactionsNewRouteImport } from './routes/__auth/transactions_.new'
import { Route as _authTransactionsBatchImportRouteImport } from './routes/__auth/transactions_.batch-import'
import { Route as _authTransactionsTransactionIdRouteImport } from './routes/__auth/transactions_.$transactionId'
import { Route as _authTransactionsQueueTabRouteImport } from './routes/__auth/transactions-queue.$tab'
import { Route as _authTransactionMonitoringFindingsRouteImport } from './routes/__auth/transaction-monitoring.findings'
import { Route as _authTransactionMonitoringEvaluationsRouteImport } from './routes/__auth/transaction-monitoring.evaluations'
import { Route as _authTransactionImportFileImportIdRouteImport } from './routes/__auth/transaction-import_.$fileImportId'
import { Route as _authTermDepositsNewRouteImport } from './routes/__auth/term-deposits_.new'
import { Route as _authStatementsStatementIdRouteImport } from './routes/__auth/statements_.$statementId'
import { Route as _authStatementBatchesKindRouteImport } from './routes/__auth/statement-batches.$kind'
import { Route as _authSissAccountsTabRouteImport } from './routes/__auth/siss-accounts.$tab'
import { Route as _authScheduledFundMovementsScheduledFundMovementIdRouteImport } from './routes/__auth/scheduled-fund-movements_.$scheduledFundMovementId'
import { Route as _authProductsProductIdRouteImport } from './routes/__auth/products_.$productId'
import { Route as _authOrganisationsBalanceSummariesRouteImport } from './routes/__auth/organisations_.balance-summaries'
import { Route as _authOrganisationsOrganisationIdRouteImport } from './routes/__auth/organisations_.$organisationId'
import { Route as _authOnboardingRequestsNewRouteImport } from './routes/__auth/onboarding-requests_.new'
import { Route as _authNotificationsNotificationIdRouteImport } from './routes/__auth/notifications_.$notificationId'
import { Route as _authFxTradesFxTradeIdRouteImport } from './routes/__auth/fx-trades_.$fxTradeId'
import { Route as _authFundUnitOrdersIdRouteImport } from './routes/__auth/fund-unit-orders_.$id'
import { Route as _authFundDistributionsNewRouteImport } from './routes/__auth/fund-distributions_.new'
import { Route as _authFundDistributionsFundDistributionIdRouteImport } from './routes/__auth/fund-distributions_.$fundDistributionId'
import { Route as _authEventsEventIdRouteImport } from './routes/__auth/events_.$eventId'
import { Route as _authEburyTradesRouteImport } from './routes/__auth/ebury.trades'
import { Route as _authEburyBeneficiariesRouteImport } from './routes/__auth/ebury.beneficiaries'
import { Route as _authDepositsNewRouteImport } from './routes/__auth/deposits_.new'
import { Route as _authDepositsDepositIdRouteImport } from './routes/__auth/deposits_.$depositId'
import { Route as _authCustodyAccountsIdRouteImport } from './routes/__auth/custody-accounts_.$id'
import { Route as _authCurrencycloudAccountIdRouteImport } from './routes/__auth/currencycloud_.$accountId'
import { Route as _authCurrencycloudRatesRouteImport } from './routes/__auth/currencycloud.rates'
import { Route as _authCashflowReportsDebugRouteImport } from './routes/__auth/cashflow-reports_.debug'
import { Route as _authCashManagementStrategyIdRouteImport } from './routes/__auth/cash-management-strategy_.$id'
import { Route as _authCalastonePricingQueueTabRouteImport } from './routes/__auth/calastone-pricing-queue.$tab'
import { Route as _authCalastoneOrdersCalastoneOrderIdRouteImport } from './routes/__auth/calastone-orders_.$calastoneOrderId'
import { Route as _authBeneficiaryAccountsNewRouteImport } from './routes/__auth/beneficiary-accounts_.new'
import { Route as _authBeneficiaryAccountsBeneficiaryAccountIdRouteImport } from './routes/__auth/beneficiary-accounts_.$beneficiaryAccountId'
import { Route as _authAssetsNewRouteImport } from './routes/__auth/assets_.new'
import { Route as _authAssetsDemoNewRouteImport } from './routes/__auth/assets_.demo-new'
import { Route as _authAssetsAssetIdRouteImport } from './routes/__auth/assets_.$assetId'
import { Route as _authAssetRulesRuleIdRouteImport } from './routes/__auth/asset-rules_.$ruleId'
import { Route as _authProductsProductIdIndexRouteImport } from './routes/__auth/products_.$productId.index'
import { Route as _authTransactionMonitoringFindingsFindingIdRouteImport } from './routes/__auth/transaction-monitoring_.findings_.$findingId'
import { Route as _authTransactionMonitoringEvaluationsEvaluationIdRouteImport } from './routes/__auth/transaction-monitoring_.evaluations_.$evaluationId'
import { Route as _authStatementBatchesKindStatementBatchIdRouteImport } from './routes/__auth/statement-batches.$kind_.$statementBatchId'
import { Route as _authProductsProductIdRateHistoryRouteImport } from './routes/__auth/products_.$productId_.rate-history'
import { Route as _authProductsProductIdUnitPricesRouteImport } from './routes/__auth/products_.$productId.unit-prices'
import { Route as _authOrganisationsOrganisationIdRulesRouteImport } from './routes/__auth/organisations_.$organisationId_.rules'
import { Route as _authLedgerTransactionsNewRouteImport } from './routes/__auth/ledger.transactions_.new'
import { Route as _authLedgerTransactionsTransactionIdRouteImport } from './routes/__auth/ledger.transactions_.$transactionId'
import { Route as _authLedgerAccountsAccountIdRouteImport } from './routes/__auth/ledger.accounts_.$accountId'
import { Route as _authEburyClientIdTradesRouteImport } from './routes/__auth/ebury_.$clientId.trades'
import { Route as _authEburyClientIdBeneficiariesRouteImport } from './routes/__auth/ebury_.$clientId.beneficiaries'
import { Route as _authAssetsAssetIdCreateDemoTransactionsRouteImport } from './routes/__auth/assets_.$assetId_.create-demo-transactions'
import { Route as _authLedgerTransactionsTransactionIdIndexRouteImport } from './routes/__auth/ledger.transactions_.$transactionId.index'
import { Route as _authLedgerAccountsAccountIdIndexRouteImport } from './routes/__auth/ledger.accounts_.$accountId.index'
import { Route as _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRouteImport } from './routes/__auth/organisations_.$organisationId_.business-entities_.$businessEntityId'
import { Route as _authLedgerTransactionsTransactionIdEntriesRouteImport } from './routes/__auth/ledger.transactions_.$transactionId.entries'
import { Route as _authLedgerAccountsAccountIdEntriesRouteImport } from './routes/__auth/ledger.accounts_.$accountId.entries'
import { Route as _authLedgerAccountsAccountIdBalancesRouteImport } from './routes/__auth/ledger.accounts_.$accountId.balances'
import { Route as _authCurrencycloudAccountIdBalancesBalanceIdRouteImport } from './routes/__auth/currencycloud_.$accountId_.balances.$balanceId'
import { Route as _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRouteImport } from './routes/__auth/organisations_.$organisationId_.business-entities_.$businessEntityId_.mercury-onboarding'
import { Route as _authLedgerTransactionsTransactionIdEntriesNewRouteImport } from './routes/__auth/ledger.transactions_.$transactionId.entries.new'

const SignOutRoute = SignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any)
const _authRoute = _authRouteImport.update({
  id: '/__auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRouteRoute = SignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileIndexRoute = UserProfileIndexRouteImport.update({
  id: '/user-profile/',
  path: '/user-profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const _authIndexRoute = _authIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authRoute,
} as any)
const UserProfileChar123SuffixChar125Route =
  UserProfileChar123SuffixChar125RouteImport.update({
    id: '/user-profile/{-$suffix}',
    path: '/user-profile/{-$suffix}',
    getParentRoute: () => rootRouteImport,
  } as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SignInRouteRoute,
} as any)
const _authYieldhubSyncRoute = _authYieldhubSyncRouteImport.update({
  id: '/yieldhub-sync',
  path: '/yieldhub-sync',
  getParentRoute: () => _authRoute,
} as any)
const _authUnitPricesRoute = _authUnitPricesRouteImport.update({
  id: '/unit-prices',
  path: '/unit-prices',
  getParentRoute: () => _authRoute,
} as any)
const _authTransfersRoute = _authTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => _authRoute,
} as any)
const _authTransferGroupsRoute = _authTransferGroupsRouteImport.update({
  id: '/transfer-groups',
  path: '/transfer-groups',
  getParentRoute: () => _authRoute,
} as any)
const _authTransactionsRoute = _authTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => _authRoute,
} as any)
const _authTransactionMonitoringRoute =
  _authTransactionMonitoringRouteImport.update({
    id: '/transaction-monitoring',
    path: '/transaction-monitoring',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionImportRoute = _authTransactionImportRouteImport.update({
  id: '/transaction-import',
  path: '/transaction-import',
  getParentRoute: () => _authRoute,
} as any)
const _authTermDepositsRoute = _authTermDepositsRouteImport.update({
  id: '/term-deposits',
  path: '/term-deposits',
  getParentRoute: () => _authRoute,
} as any)
const _authStripePayoutQueueRoute = _authStripePayoutQueueRouteImport.update({
  id: '/stripe-payout-queue',
  path: '/stripe-payout-queue',
  getParentRoute: () => _authRoute,
} as any)
const _authStatementsRoute = _authStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => _authRoute,
} as any)
const _authScheduledFundMovementsRoute =
  _authScheduledFundMovementsRouteImport.update({
    id: '/scheduled-fund-movements',
    path: '/scheduled-fund-movements',
    getParentRoute: () => _authRoute,
  } as any)
const _authProvidersRoute = _authProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => _authRoute,
} as any)
const _authProductsRoute = _authProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => _authRoute,
} as any)
const _authPlaygroundRoute = _authPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => _authRoute,
} as any)
const _authOrganisationsRoute = _authOrganisationsRouteImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => _authRoute,
} as any)
const _authOnboardingRequestsRoute = _authOnboardingRequestsRouteImport.update({
  id: '/onboarding-requests',
  path: '/onboarding-requests',
  getParentRoute: () => _authRoute,
} as any)
const _authNonProcessingDaysRoute = _authNonProcessingDaysRouteImport.update({
  id: '/non-processing-days',
  path: '/non-processing-days',
  getParentRoute: () => _authRoute,
} as any)
const _authMfaTestRoute = _authMfaTestRouteImport.update({
  id: '/mfa-test',
  path: '/mfa-test',
  getParentRoute: () => _authRoute,
} as any)
const _authLogosRoute = _authLogosRouteImport.update({
  id: '/logos',
  path: '/logos',
  getParentRoute: () => _authRoute,
} as any)
const _authKycQueueRoute = _authKycQueueRouteImport.update({
  id: '/kyc-queue',
  path: '/kyc-queue',
  getParentRoute: () => _authRoute,
} as any)
const _authJobsRoute = _authJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => _authRoute,
} as any)
const _authHighRiskJurisdictionsRoute =
  _authHighRiskJurisdictionsRouteImport.update({
    id: '/high-risk-jurisdictions',
    path: '/high-risk-jurisdictions',
    getParentRoute: () => _authRoute,
  } as any)
const _authFxTradesRoute = _authFxTradesRouteImport.update({
  id: '/fx-trades',
  path: '/fx-trades',
  getParentRoute: () => _authRoute,
} as any)
const _authFundDistributionsRoute = _authFundDistributionsRouteImport.update({
  id: '/fund-distributions',
  path: '/fund-distributions',
  getParentRoute: () => _authRoute,
} as any)
const _authFeatureFlagsRoute = _authFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => _authRoute,
} as any)
const _authExternalProvidersRoute = _authExternalProvidersRouteImport.update({
  id: '/external-providers',
  path: '/external-providers',
  getParentRoute: () => _authRoute,
} as any)
const _authEventsRoute = _authEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => _authRoute,
} as any)
const _authEburyRoute = _authEburyRouteImport.update({
  id: '/ebury',
  path: '/ebury',
  getParentRoute: () => _authRoute,
} as any)
const _authDesignRoute = _authDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => _authRoute,
} as any)
const _authDepositsRoute = _authDepositsRouteImport.update({
  id: '/deposits',
  path: '/deposits',
  getParentRoute: () => _authRoute,
} as any)
const _authCustodyAccountsRoute = _authCustodyAccountsRouteImport.update({
  id: '/custody-accounts',
  path: '/custody-accounts',
  getParentRoute: () => _authRoute,
} as any)
const _authCurrencycloudRoute = _authCurrencycloudRouteImport.update({
  id: '/currencycloud',
  path: '/currencycloud',
  getParentRoute: () => _authRoute,
} as any)
const _authCronRoute = _authCronRouteImport.update({
  id: '/cron',
  path: '/cron',
  getParentRoute: () => _authRoute,
} as any)
const _authCashflowReportsRoute = _authCashflowReportsRouteImport.update({
  id: '/cashflow-reports',
  path: '/cashflow-reports',
  getParentRoute: () => _authRoute,
} as any)
const _authCashManagementStrategiesRoute =
  _authCashManagementStrategiesRouteImport.update({
    id: '/cash-management-strategies',
    path: '/cash-management-strategies',
    getParentRoute: () => _authRoute,
  } as any)
const _authCalastoneOrdersRoute = _authCalastoneOrdersRouteImport.update({
  id: '/calastone-orders',
  path: '/calastone-orders',
  getParentRoute: () => _authRoute,
} as any)
const _authBeneficiaryAccountsRoute =
  _authBeneficiaryAccountsRouteImport.update({
    id: '/beneficiary-accounts',
    path: '/beneficiary-accounts',
    getParentRoute: () => _authRoute,
  } as any)
const _authAssetsRoute = _authAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => _authRoute,
} as any)
const _authAssetRulesRoute = _authAssetRulesRouteImport.update({
  id: '/asset-rules',
  path: '/asset-rules',
  getParentRoute: () => _authRoute,
} as any)
const _authAdminRoute = _authAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => _authRoute,
} as any)
const _authSplatRoute = _authSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => _authRoute,
} as any)
const _authEburyIndexRoute = _authEburyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authEburyRoute,
} as any)
const _authCurrencycloudIndexRoute = _authCurrencycloudIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authCurrencycloudRoute,
} as any)
const _authYieldhubSyncFileIdRoute = _authYieldhubSyncFileIdRouteImport.update({
  id: '/yieldhub-sync_/$fileId',
  path: '/yieldhub-sync/$fileId',
  getParentRoute: () => _authRoute,
} as any)
const _authTransfersNewRoute = _authTransfersNewRouteImport.update({
  id: '/transfers_/new',
  path: '/transfers/new',
  getParentRoute: () => _authRoute,
} as any)
const _authTransfersTransferIdRoute =
  _authTransfersTransferIdRouteImport.update({
    id: '/transfers_/$transferId',
    path: '/transfers/$transferId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransferGroupsTransferGroupIdRoute =
  _authTransferGroupsTransferGroupIdRouteImport.update({
    id: '/transfer-groups_/$transferGroupId',
    path: '/transfer-groups/$transferGroupId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionsNewRoute = _authTransactionsNewRouteImport.update({
  id: '/transactions_/new',
  path: '/transactions/new',
  getParentRoute: () => _authRoute,
} as any)
const _authTransactionsBatchImportRoute =
  _authTransactionsBatchImportRouteImport.update({
    id: '/transactions_/batch-import',
    path: '/transactions/batch-import',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionsTransactionIdRoute =
  _authTransactionsTransactionIdRouteImport.update({
    id: '/transactions_/$transactionId',
    path: '/transactions/$transactionId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionsQueueTabRoute =
  _authTransactionsQueueTabRouteImport.update({
    id: '/transactions-queue/$tab',
    path: '/transactions-queue/$tab',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionMonitoringFindingsRoute =
  _authTransactionMonitoringFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => _authTransactionMonitoringRoute,
  } as any)
const _authTransactionMonitoringEvaluationsRoute =
  _authTransactionMonitoringEvaluationsRouteImport.update({
    id: '/evaluations',
    path: '/evaluations',
    getParentRoute: () => _authTransactionMonitoringRoute,
  } as any)
const _authTransactionImportFileImportIdRoute =
  _authTransactionImportFileImportIdRouteImport.update({
    id: '/transaction-import_/$fileImportId',
    path: '/transaction-import/$fileImportId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTermDepositsNewRoute = _authTermDepositsNewRouteImport.update({
  id: '/term-deposits_/new',
  path: '/term-deposits/new',
  getParentRoute: () => _authRoute,
} as any)
const _authStatementsStatementIdRoute =
  _authStatementsStatementIdRouteImport.update({
    id: '/statements_/$statementId',
    path: '/statements/$statementId',
    getParentRoute: () => _authRoute,
  } as any)
const _authStatementBatchesKindRoute =
  _authStatementBatchesKindRouteImport.update({
    id: '/statement-batches/$kind',
    path: '/statement-batches/$kind',
    getParentRoute: () => _authRoute,
  } as any)
const _authSissAccountsTabRoute = _authSissAccountsTabRouteImport.update({
  id: '/siss-accounts/$tab',
  path: '/siss-accounts/$tab',
  getParentRoute: () => _authRoute,
} as any)
const _authScheduledFundMovementsScheduledFundMovementIdRoute =
  _authScheduledFundMovementsScheduledFundMovementIdRouteImport.update({
    id: '/scheduled-fund-movements_/$scheduledFundMovementId',
    path: '/scheduled-fund-movements/$scheduledFundMovementId',
    getParentRoute: () => _authRoute,
  } as any)
const _authProductsProductIdRoute = _authProductsProductIdRouteImport.update({
  id: '/products_/$productId',
  path: '/products/$productId',
  getParentRoute: () => _authRoute,
} as any)
const _authOrganisationsBalanceSummariesRoute =
  _authOrganisationsBalanceSummariesRouteImport.update({
    id: '/organisations_/balance-summaries',
    path: '/organisations/balance-summaries',
    getParentRoute: () => _authRoute,
  } as any)
const _authOrganisationsOrganisationIdRoute =
  _authOrganisationsOrganisationIdRouteImport.update({
    id: '/organisations_/$organisationId',
    path: '/organisations/$organisationId',
    getParentRoute: () => _authRoute,
  } as any)
const _authOnboardingRequestsNewRoute =
  _authOnboardingRequestsNewRouteImport.update({
    id: '/onboarding-requests_/new',
    path: '/onboarding-requests/new',
    getParentRoute: () => _authRoute,
  } as any)
const _authNotificationsNotificationIdRoute =
  _authNotificationsNotificationIdRouteImport.update({
    id: '/notifications_/$notificationId',
    path: '/notifications/$notificationId',
    getParentRoute: () => _authRoute,
  } as any)
const _authFxTradesFxTradeIdRoute = _authFxTradesFxTradeIdRouteImport.update({
  id: '/fx-trades_/$fxTradeId',
  path: '/fx-trades/$fxTradeId',
  getParentRoute: () => _authRoute,
} as any)
const _authFundUnitOrdersIdRoute = _authFundUnitOrdersIdRouteImport.update({
  id: '/fund-unit-orders_/$id',
  path: '/fund-unit-orders/$id',
  getParentRoute: () => _authRoute,
} as any)
const _authFundDistributionsNewRoute =
  _authFundDistributionsNewRouteImport.update({
    id: '/fund-distributions_/new',
    path: '/fund-distributions/new',
    getParentRoute: () => _authRoute,
  } as any)
const _authFundDistributionsFundDistributionIdRoute =
  _authFundDistributionsFundDistributionIdRouteImport.update({
    id: '/fund-distributions_/$fundDistributionId',
    path: '/fund-distributions/$fundDistributionId',
    getParentRoute: () => _authRoute,
  } as any)
const _authEventsEventIdRoute = _authEventsEventIdRouteImport.update({
  id: '/events_/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => _authRoute,
} as any)
const _authEburyTradesRoute = _authEburyTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => _authEburyRoute,
} as any)
const _authEburyBeneficiariesRoute = _authEburyBeneficiariesRouteImport.update({
  id: '/beneficiaries',
  path: '/beneficiaries',
  getParentRoute: () => _authEburyRoute,
} as any)
const _authDepositsNewRoute = _authDepositsNewRouteImport.update({
  id: '/deposits_/new',
  path: '/deposits/new',
  getParentRoute: () => _authRoute,
} as any)
const _authDepositsDepositIdRoute = _authDepositsDepositIdRouteImport.update({
  id: '/deposits_/$depositId',
  path: '/deposits/$depositId',
  getParentRoute: () => _authRoute,
} as any)
const _authCustodyAccountsIdRoute = _authCustodyAccountsIdRouteImport.update({
  id: '/custody-accounts_/$id',
  path: '/custody-accounts/$id',
  getParentRoute: () => _authRoute,
} as any)
const _authCurrencycloudAccountIdRoute =
  _authCurrencycloudAccountIdRouteImport.update({
    id: '/currencycloud_/$accountId',
    path: '/currencycloud/$accountId',
    getParentRoute: () => _authRoute,
  } as any)
const _authCurrencycloudRatesRoute = _authCurrencycloudRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => _authCurrencycloudRoute,
} as any)
const _authCashflowReportsDebugRoute =
  _authCashflowReportsDebugRouteImport.update({
    id: '/cashflow-reports_/debug',
    path: '/cashflow-reports/debug',
    getParentRoute: () => _authRoute,
  } as any)
const _authCashManagementStrategyIdRoute =
  _authCashManagementStrategyIdRouteImport.update({
    id: '/cash-management-strategy_/$id',
    path: '/cash-management-strategy/$id',
    getParentRoute: () => _authRoute,
  } as any)
const _authCalastonePricingQueueTabRoute =
  _authCalastonePricingQueueTabRouteImport.update({
    id: '/calastone-pricing-queue/$tab',
    path: '/calastone-pricing-queue/$tab',
    getParentRoute: () => _authRoute,
  } as any)
const _authCalastoneOrdersCalastoneOrderIdRoute =
  _authCalastoneOrdersCalastoneOrderIdRouteImport.update({
    id: '/calastone-orders_/$calastoneOrderId',
    path: '/calastone-orders/$calastoneOrderId',
    getParentRoute: () => _authRoute,
  } as any)
const _authBeneficiaryAccountsNewRoute =
  _authBeneficiaryAccountsNewRouteImport.update({
    id: '/beneficiary-accounts_/new',
    path: '/beneficiary-accounts/new',
    getParentRoute: () => _authRoute,
  } as any)
const _authBeneficiaryAccountsBeneficiaryAccountIdRoute =
  _authBeneficiaryAccountsBeneficiaryAccountIdRouteImport.update({
    id: '/beneficiary-accounts_/$beneficiaryAccountId',
    path: '/beneficiary-accounts/$beneficiaryAccountId',
    getParentRoute: () => _authRoute,
  } as any)
const _authAssetsNewRoute = _authAssetsNewRouteImport.update({
  id: '/assets_/new',
  path: '/assets/new',
  getParentRoute: () => _authRoute,
} as any)
const _authAssetsDemoNewRoute = _authAssetsDemoNewRouteImport.update({
  id: '/assets_/demo-new',
  path: '/assets/demo-new',
  getParentRoute: () => _authRoute,
} as any)
const _authAssetsAssetIdRoute = _authAssetsAssetIdRouteImport.update({
  id: '/assets_/$assetId',
  path: '/assets/$assetId',
  getParentRoute: () => _authRoute,
} as any)
const _authAssetRulesRuleIdRoute = _authAssetRulesRuleIdRouteImport.update({
  id: '/asset-rules_/$ruleId',
  path: '/asset-rules/$ruleId',
  getParentRoute: () => _authRoute,
} as any)
const _authProductsProductIdIndexRoute =
  _authProductsProductIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authProductsProductIdRoute,
  } as any)
const _authTransactionMonitoringFindingsFindingIdRoute =
  _authTransactionMonitoringFindingsFindingIdRouteImport.update({
    id: '/transaction-monitoring_/findings_/$findingId',
    path: '/transaction-monitoring/findings/$findingId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTransactionMonitoringEvaluationsEvaluationIdRoute =
  _authTransactionMonitoringEvaluationsEvaluationIdRouteImport.update({
    id: '/transaction-monitoring_/evaluations_/$evaluationId',
    path: '/transaction-monitoring/evaluations/$evaluationId',
    getParentRoute: () => _authRoute,
  } as any)
const _authStatementBatchesKindStatementBatchIdRoute =
  _authStatementBatchesKindStatementBatchIdRouteImport.update({
    id: '/statement-batches/$kind_/$statementBatchId',
    path: '/statement-batches/$kind/$statementBatchId',
    getParentRoute: () => _authRoute,
  } as any)
const _authProductsProductIdRateHistoryRoute =
  _authProductsProductIdRateHistoryRouteImport.update({
    id: '/products_/$productId_/rate-history',
    path: '/products/$productId/rate-history',
    getParentRoute: () => _authRoute,
  } as any)
const _authProductsProductIdUnitPricesRoute =
  _authProductsProductIdUnitPricesRouteImport.update({
    id: '/unit-prices',
    path: '/unit-prices',
    getParentRoute: () => _authProductsProductIdRoute,
  } as any)
const _authOrganisationsOrganisationIdRulesRoute =
  _authOrganisationsOrganisationIdRulesRouteImport.update({
    id: '/organisations_/$organisationId_/rules',
    path: '/organisations/$organisationId/rules',
    getParentRoute: () => _authRoute,
  } as any)
const _authLedgerTransactionsNewRoute =
  _authLedgerTransactionsNewRouteImport.update({
    id: '/ledger/transactions_/new',
    path: '/ledger/transactions/new',
    getParentRoute: () => _authRoute,
  } as any)
const _authLedgerTransactionsTransactionIdRoute =
  _authLedgerTransactionsTransactionIdRouteImport.update({
    id: '/ledger/transactions_/$transactionId',
    path: '/ledger/transactions/$transactionId',
    getParentRoute: () => _authRoute,
  } as any)
const _authLedgerAccountsAccountIdRoute =
  _authLedgerAccountsAccountIdRouteImport.update({
    id: '/ledger/accounts_/$accountId',
    path: '/ledger/accounts/$accountId',
    getParentRoute: () => _authRoute,
  } as any)
const _authEburyClientIdTradesRoute =
  _authEburyClientIdTradesRouteImport.update({
    id: '/ebury_/$clientId/trades',
    path: '/ebury/$clientId/trades',
    getParentRoute: () => _authRoute,
  } as any)
const _authEburyClientIdBeneficiariesRoute =
  _authEburyClientIdBeneficiariesRouteImport.update({
    id: '/ebury_/$clientId/beneficiaries',
    path: '/ebury/$clientId/beneficiaries',
    getParentRoute: () => _authRoute,
  } as any)
const _authAssetsAssetIdCreateDemoTransactionsRoute =
  _authAssetsAssetIdCreateDemoTransactionsRouteImport.update({
    id: '/assets_/$assetId_/create-demo-transactions',
    path: '/assets/$assetId/create-demo-transactions',
    getParentRoute: () => _authRoute,
  } as any)
const _authLedgerTransactionsTransactionIdIndexRoute =
  _authLedgerTransactionsTransactionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authLedgerTransactionsTransactionIdRoute,
  } as any)
const _authLedgerAccountsAccountIdIndexRoute =
  _authLedgerAccountsAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authLedgerAccountsAccountIdRoute,
  } as any)
const _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute =
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRouteImport.update(
    {
      id: '/organisations_/$organisationId_/business-entities_/$businessEntityId',
      path: '/organisations/$organisationId/business-entities/$businessEntityId',
      getParentRoute: () => _authRoute,
    } as any,
  )
const _authLedgerTransactionsTransactionIdEntriesRoute =
  _authLedgerTransactionsTransactionIdEntriesRouteImport.update({
    id: '/entries',
    path: '/entries',
    getParentRoute: () => _authLedgerTransactionsTransactionIdRoute,
  } as any)
const _authLedgerAccountsAccountIdEntriesRoute =
  _authLedgerAccountsAccountIdEntriesRouteImport.update({
    id: '/entries',
    path: '/entries',
    getParentRoute: () => _authLedgerAccountsAccountIdRoute,
  } as any)
const _authLedgerAccountsAccountIdBalancesRoute =
  _authLedgerAccountsAccountIdBalancesRouteImport.update({
    id: '/balances',
    path: '/balances',
    getParentRoute: () => _authLedgerAccountsAccountIdRoute,
  } as any)
const _authCurrencycloudAccountIdBalancesBalanceIdRoute =
  _authCurrencycloudAccountIdBalancesBalanceIdRouteImport.update({
    id: '/currencycloud_/$accountId_/balances/$balanceId',
    path: '/currencycloud/$accountId/balances/$balanceId',
    getParentRoute: () => _authRoute,
  } as any)
const _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute =
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRouteImport.update(
    {
      id: '/organisations_/$organisationId_/business-entities_/$businessEntityId_/mercury-onboarding',
      path: '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding',
      getParentRoute: () => _authRoute,
    } as any,
  )
const _authLedgerTransactionsTransactionIdEntriesNewRoute =
  _authLedgerTransactionsTransactionIdEntriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => _authLedgerTransactionsTransactionIdEntriesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/sign-in': typeof SignInRouteRouteWithChildren
  '/sign-out': typeof SignOutRoute
  '/$': typeof _authSplatRoute
  '/admin': typeof _authAdminRoute
  '/asset-rules': typeof _authAssetRulesRoute
  '/assets': typeof _authAssetsRoute
  '/beneficiary-accounts': typeof _authBeneficiaryAccountsRoute
  '/calastone-orders': typeof _authCalastoneOrdersRoute
  '/cash-management-strategies': typeof _authCashManagementStrategiesRoute
  '/cashflow-reports': typeof _authCashflowReportsRoute
  '/cron': typeof _authCronRoute
  '/currencycloud': typeof _authCurrencycloudRouteWithChildren
  '/custody-accounts': typeof _authCustodyAccountsRoute
  '/deposits': typeof _authDepositsRoute
  '/design': typeof _authDesignRoute
  '/ebury': typeof _authEburyRouteWithChildren
  '/events': typeof _authEventsRoute
  '/external-providers': typeof _authExternalProvidersRoute
  '/feature-flags': typeof _authFeatureFlagsRoute
  '/fund-distributions': typeof _authFundDistributionsRoute
  '/fx-trades': typeof _authFxTradesRoute
  '/high-risk-jurisdictions': typeof _authHighRiskJurisdictionsRoute
  '/jobs': typeof _authJobsRoute
  '/kyc-queue': typeof _authKycQueueRoute
  '/logos': typeof _authLogosRoute
  '/mfa-test': typeof _authMfaTestRoute
  '/non-processing-days': typeof _authNonProcessingDaysRoute
  '/onboarding-requests': typeof _authOnboardingRequestsRoute
  '/organisations': typeof _authOrganisationsRoute
  '/playground': typeof _authPlaygroundRoute
  '/products': typeof _authProductsRoute
  '/providers': typeof _authProvidersRoute
  '/scheduled-fund-movements': typeof _authScheduledFundMovementsRoute
  '/statements': typeof _authStatementsRoute
  '/stripe-payout-queue': typeof _authStripePayoutQueueRoute
  '/term-deposits': typeof _authTermDepositsRoute
  '/transaction-import': typeof _authTransactionImportRoute
  '/transaction-monitoring': typeof _authTransactionMonitoringRouteWithChildren
  '/transactions': typeof _authTransactionsRoute
  '/transfer-groups': typeof _authTransferGroupsRoute
  '/transfers': typeof _authTransfersRoute
  '/unit-prices': typeof _authUnitPricesRoute
  '/yieldhub-sync': typeof _authYieldhubSyncRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/user-profile/{-$suffix}': typeof UserProfileChar123SuffixChar125Route
  '/': typeof _authIndexRoute
  '/user-profile': typeof UserProfileIndexRoute
  '/asset-rules/$ruleId': typeof _authAssetRulesRuleIdRoute
  '/assets/$assetId': typeof _authAssetsAssetIdRoute
  '/assets/demo-new': typeof _authAssetsDemoNewRoute
  '/assets/new': typeof _authAssetsNewRoute
  '/beneficiary-accounts/$beneficiaryAccountId': typeof _authBeneficiaryAccountsBeneficiaryAccountIdRoute
  '/beneficiary-accounts/new': typeof _authBeneficiaryAccountsNewRoute
  '/calastone-orders/$calastoneOrderId': typeof _authCalastoneOrdersCalastoneOrderIdRoute
  '/calastone-pricing-queue/$tab': typeof _authCalastonePricingQueueTabRoute
  '/cash-management-strategy/$id': typeof _authCashManagementStrategyIdRoute
  '/cashflow-reports/debug': typeof _authCashflowReportsDebugRoute
  '/currencycloud/rates': typeof _authCurrencycloudRatesRoute
  '/currencycloud/$accountId': typeof _authCurrencycloudAccountIdRoute
  '/custody-accounts/$id': typeof _authCustodyAccountsIdRoute
  '/deposits/$depositId': typeof _authDepositsDepositIdRoute
  '/deposits/new': typeof _authDepositsNewRoute
  '/ebury/beneficiaries': typeof _authEburyBeneficiariesRoute
  '/ebury/trades': typeof _authEburyTradesRoute
  '/events/$eventId': typeof _authEventsEventIdRoute
  '/fund-distributions/$fundDistributionId': typeof _authFundDistributionsFundDistributionIdRoute
  '/fund-distributions/new': typeof _authFundDistributionsNewRoute
  '/fund-unit-orders/$id': typeof _authFundUnitOrdersIdRoute
  '/fx-trades/$fxTradeId': typeof _authFxTradesFxTradeIdRoute
  '/notifications/$notificationId': typeof _authNotificationsNotificationIdRoute
  '/onboarding-requests/new': typeof _authOnboardingRequestsNewRoute
  '/organisations/$organisationId': typeof _authOrganisationsOrganisationIdRoute
  '/organisations/balance-summaries': typeof _authOrganisationsBalanceSummariesRoute
  '/products/$productId': typeof _authProductsProductIdRouteWithChildren
  '/scheduled-fund-movements/$scheduledFundMovementId': typeof _authScheduledFundMovementsScheduledFundMovementIdRoute
  '/siss-accounts/$tab': typeof _authSissAccountsTabRoute
  '/statement-batches/$kind': typeof _authStatementBatchesKindRoute
  '/statements/$statementId': typeof _authStatementsStatementIdRoute
  '/term-deposits/new': typeof _authTermDepositsNewRoute
  '/transaction-import/$fileImportId': typeof _authTransactionImportFileImportIdRoute
  '/transaction-monitoring/evaluations': typeof _authTransactionMonitoringEvaluationsRoute
  '/transaction-monitoring/findings': typeof _authTransactionMonitoringFindingsRoute
  '/transactions-queue/$tab': typeof _authTransactionsQueueTabRoute
  '/transactions/$transactionId': typeof _authTransactionsTransactionIdRoute
  '/transactions/batch-import': typeof _authTransactionsBatchImportRoute
  '/transactions/new': typeof _authTransactionsNewRoute
  '/transfer-groups/$transferGroupId': typeof _authTransferGroupsTransferGroupIdRoute
  '/transfers/$transferId': typeof _authTransfersTransferIdRoute
  '/transfers/new': typeof _authTransfersNewRoute
  '/yieldhub-sync/$fileId': typeof _authYieldhubSyncFileIdRoute
  '/currencycloud/': typeof _authCurrencycloudIndexRoute
  '/ebury/': typeof _authEburyIndexRoute
  '/assets/$assetId/create-demo-transactions': typeof _authAssetsAssetIdCreateDemoTransactionsRoute
  '/ebury/$clientId/beneficiaries': typeof _authEburyClientIdBeneficiariesRoute
  '/ebury/$clientId/trades': typeof _authEburyClientIdTradesRoute
  '/ledger/accounts/$accountId': typeof _authLedgerAccountsAccountIdRouteWithChildren
  '/ledger/transactions/$transactionId': typeof _authLedgerTransactionsTransactionIdRouteWithChildren
  '/ledger/transactions/new': typeof _authLedgerTransactionsNewRoute
  '/organisations/$organisationId/rules': typeof _authOrganisationsOrganisationIdRulesRoute
  '/products/$productId/unit-prices': typeof _authProductsProductIdUnitPricesRoute
  '/products/$productId/rate-history': typeof _authProductsProductIdRateHistoryRoute
  '/statement-batches/$kind/$statementBatchId': typeof _authStatementBatchesKindStatementBatchIdRoute
  '/transaction-monitoring/evaluations/$evaluationId': typeof _authTransactionMonitoringEvaluationsEvaluationIdRoute
  '/transaction-monitoring/findings/$findingId': typeof _authTransactionMonitoringFindingsFindingIdRoute
  '/products/$productId/': typeof _authProductsProductIdIndexRoute
  '/currencycloud/$accountId/balances/$balanceId': typeof _authCurrencycloudAccountIdBalancesBalanceIdRoute
  '/ledger/accounts/$accountId/balances': typeof _authLedgerAccountsAccountIdBalancesRoute
  '/ledger/accounts/$accountId/entries': typeof _authLedgerAccountsAccountIdEntriesRoute
  '/ledger/transactions/$transactionId/entries': typeof _authLedgerTransactionsTransactionIdEntriesRouteWithChildren
  '/organisations/$organisationId/business-entities/$businessEntityId': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute
  '/ledger/accounts/$accountId/': typeof _authLedgerAccountsAccountIdIndexRoute
  '/ledger/transactions/$transactionId/': typeof _authLedgerTransactionsTransactionIdIndexRoute
  '/ledger/transactions/$transactionId/entries/new': typeof _authLedgerTransactionsTransactionIdEntriesNewRoute
  '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRouteRouteWithChildren
  '/sign-out': typeof SignOutRoute
  '/$': typeof _authSplatRoute
  '/admin': typeof _authAdminRoute
  '/asset-rules': typeof _authAssetRulesRoute
  '/assets': typeof _authAssetsRoute
  '/beneficiary-accounts': typeof _authBeneficiaryAccountsRoute
  '/calastone-orders': typeof _authCalastoneOrdersRoute
  '/cash-management-strategies': typeof _authCashManagementStrategiesRoute
  '/cashflow-reports': typeof _authCashflowReportsRoute
  '/cron': typeof _authCronRoute
  '/custody-accounts': typeof _authCustodyAccountsRoute
  '/deposits': typeof _authDepositsRoute
  '/design': typeof _authDesignRoute
  '/events': typeof _authEventsRoute
  '/external-providers': typeof _authExternalProvidersRoute
  '/feature-flags': typeof _authFeatureFlagsRoute
  '/fund-distributions': typeof _authFundDistributionsRoute
  '/fx-trades': typeof _authFxTradesRoute
  '/high-risk-jurisdictions': typeof _authHighRiskJurisdictionsRoute
  '/jobs': typeof _authJobsRoute
  '/kyc-queue': typeof _authKycQueueRoute
  '/logos': typeof _authLogosRoute
  '/mfa-test': typeof _authMfaTestRoute
  '/non-processing-days': typeof _authNonProcessingDaysRoute
  '/onboarding-requests': typeof _authOnboardingRequestsRoute
  '/organisations': typeof _authOrganisationsRoute
  '/playground': typeof _authPlaygroundRoute
  '/products': typeof _authProductsRoute
  '/providers': typeof _authProvidersRoute
  '/scheduled-fund-movements': typeof _authScheduledFundMovementsRoute
  '/statements': typeof _authStatementsRoute
  '/stripe-payout-queue': typeof _authStripePayoutQueueRoute
  '/term-deposits': typeof _authTermDepositsRoute
  '/transaction-import': typeof _authTransactionImportRoute
  '/transaction-monitoring': typeof _authTransactionMonitoringRouteWithChildren
  '/transactions': typeof _authTransactionsRoute
  '/transfer-groups': typeof _authTransferGroupsRoute
  '/transfers': typeof _authTransfersRoute
  '/unit-prices': typeof _authUnitPricesRoute
  '/yieldhub-sync': typeof _authYieldhubSyncRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/user-profile/{-$suffix}': typeof UserProfileChar123SuffixChar125Route
  '/': typeof _authIndexRoute
  '/user-profile': typeof UserProfileIndexRoute
  '/asset-rules/$ruleId': typeof _authAssetRulesRuleIdRoute
  '/assets/$assetId': typeof _authAssetsAssetIdRoute
  '/assets/demo-new': typeof _authAssetsDemoNewRoute
  '/assets/new': typeof _authAssetsNewRoute
  '/beneficiary-accounts/$beneficiaryAccountId': typeof _authBeneficiaryAccountsBeneficiaryAccountIdRoute
  '/beneficiary-accounts/new': typeof _authBeneficiaryAccountsNewRoute
  '/calastone-orders/$calastoneOrderId': typeof _authCalastoneOrdersCalastoneOrderIdRoute
  '/calastone-pricing-queue/$tab': typeof _authCalastonePricingQueueTabRoute
  '/cash-management-strategy/$id': typeof _authCashManagementStrategyIdRoute
  '/cashflow-reports/debug': typeof _authCashflowReportsDebugRoute
  '/currencycloud/rates': typeof _authCurrencycloudRatesRoute
  '/currencycloud/$accountId': typeof _authCurrencycloudAccountIdRoute
  '/custody-accounts/$id': typeof _authCustodyAccountsIdRoute
  '/deposits/$depositId': typeof _authDepositsDepositIdRoute
  '/deposits/new': typeof _authDepositsNewRoute
  '/ebury/beneficiaries': typeof _authEburyBeneficiariesRoute
  '/ebury/trades': typeof _authEburyTradesRoute
  '/events/$eventId': typeof _authEventsEventIdRoute
  '/fund-distributions/$fundDistributionId': typeof _authFundDistributionsFundDistributionIdRoute
  '/fund-distributions/new': typeof _authFundDistributionsNewRoute
  '/fund-unit-orders/$id': typeof _authFundUnitOrdersIdRoute
  '/fx-trades/$fxTradeId': typeof _authFxTradesFxTradeIdRoute
  '/notifications/$notificationId': typeof _authNotificationsNotificationIdRoute
  '/onboarding-requests/new': typeof _authOnboardingRequestsNewRoute
  '/organisations/$organisationId': typeof _authOrganisationsOrganisationIdRoute
  '/organisations/balance-summaries': typeof _authOrganisationsBalanceSummariesRoute
  '/scheduled-fund-movements/$scheduledFundMovementId': typeof _authScheduledFundMovementsScheduledFundMovementIdRoute
  '/siss-accounts/$tab': typeof _authSissAccountsTabRoute
  '/statement-batches/$kind': typeof _authStatementBatchesKindRoute
  '/statements/$statementId': typeof _authStatementsStatementIdRoute
  '/term-deposits/new': typeof _authTermDepositsNewRoute
  '/transaction-import/$fileImportId': typeof _authTransactionImportFileImportIdRoute
  '/transaction-monitoring/evaluations': typeof _authTransactionMonitoringEvaluationsRoute
  '/transaction-monitoring/findings': typeof _authTransactionMonitoringFindingsRoute
  '/transactions-queue/$tab': typeof _authTransactionsQueueTabRoute
  '/transactions/$transactionId': typeof _authTransactionsTransactionIdRoute
  '/transactions/batch-import': typeof _authTransactionsBatchImportRoute
  '/transactions/new': typeof _authTransactionsNewRoute
  '/transfer-groups/$transferGroupId': typeof _authTransferGroupsTransferGroupIdRoute
  '/transfers/$transferId': typeof _authTransfersTransferIdRoute
  '/transfers/new': typeof _authTransfersNewRoute
  '/yieldhub-sync/$fileId': typeof _authYieldhubSyncFileIdRoute
  '/currencycloud': typeof _authCurrencycloudIndexRoute
  '/ebury': typeof _authEburyIndexRoute
  '/assets/$assetId/create-demo-transactions': typeof _authAssetsAssetIdCreateDemoTransactionsRoute
  '/ebury/$clientId/beneficiaries': typeof _authEburyClientIdBeneficiariesRoute
  '/ebury/$clientId/trades': typeof _authEburyClientIdTradesRoute
  '/ledger/transactions/new': typeof _authLedgerTransactionsNewRoute
  '/organisations/$organisationId/rules': typeof _authOrganisationsOrganisationIdRulesRoute
  '/products/$productId/unit-prices': typeof _authProductsProductIdUnitPricesRoute
  '/products/$productId/rate-history': typeof _authProductsProductIdRateHistoryRoute
  '/statement-batches/$kind/$statementBatchId': typeof _authStatementBatchesKindStatementBatchIdRoute
  '/transaction-monitoring/evaluations/$evaluationId': typeof _authTransactionMonitoringEvaluationsEvaluationIdRoute
  '/transaction-monitoring/findings/$findingId': typeof _authTransactionMonitoringFindingsFindingIdRoute
  '/products/$productId': typeof _authProductsProductIdIndexRoute
  '/currencycloud/$accountId/balances/$balanceId': typeof _authCurrencycloudAccountIdBalancesBalanceIdRoute
  '/ledger/accounts/$accountId/balances': typeof _authLedgerAccountsAccountIdBalancesRoute
  '/ledger/accounts/$accountId/entries': typeof _authLedgerAccountsAccountIdEntriesRoute
  '/ledger/transactions/$transactionId/entries': typeof _authLedgerTransactionsTransactionIdEntriesRouteWithChildren
  '/organisations/$organisationId/business-entities/$businessEntityId': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute
  '/ledger/accounts/$accountId': typeof _authLedgerAccountsAccountIdIndexRoute
  '/ledger/transactions/$transactionId': typeof _authLedgerTransactionsTransactionIdIndexRoute
  '/ledger/transactions/$transactionId/entries/new': typeof _authLedgerTransactionsTransactionIdEntriesNewRoute
  '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/sign-in': typeof SignInRouteRouteWithChildren
  '/__auth': typeof _authRouteWithChildren
  '/sign-out': typeof SignOutRoute
  '/__auth/$': typeof _authSplatRoute
  '/__auth/admin': typeof _authAdminRoute
  '/__auth/asset-rules': typeof _authAssetRulesRoute
  '/__auth/assets': typeof _authAssetsRoute
  '/__auth/beneficiary-accounts': typeof _authBeneficiaryAccountsRoute
  '/__auth/calastone-orders': typeof _authCalastoneOrdersRoute
  '/__auth/cash-management-strategies': typeof _authCashManagementStrategiesRoute
  '/__auth/cashflow-reports': typeof _authCashflowReportsRoute
  '/__auth/cron': typeof _authCronRoute
  '/__auth/currencycloud': typeof _authCurrencycloudRouteWithChildren
  '/__auth/custody-accounts': typeof _authCustodyAccountsRoute
  '/__auth/deposits': typeof _authDepositsRoute
  '/__auth/design': typeof _authDesignRoute
  '/__auth/ebury': typeof _authEburyRouteWithChildren
  '/__auth/events': typeof _authEventsRoute
  '/__auth/external-providers': typeof _authExternalProvidersRoute
  '/__auth/feature-flags': typeof _authFeatureFlagsRoute
  '/__auth/fund-distributions': typeof _authFundDistributionsRoute
  '/__auth/fx-trades': typeof _authFxTradesRoute
  '/__auth/high-risk-jurisdictions': typeof _authHighRiskJurisdictionsRoute
  '/__auth/jobs': typeof _authJobsRoute
  '/__auth/kyc-queue': typeof _authKycQueueRoute
  '/__auth/logos': typeof _authLogosRoute
  '/__auth/mfa-test': typeof _authMfaTestRoute
  '/__auth/non-processing-days': typeof _authNonProcessingDaysRoute
  '/__auth/onboarding-requests': typeof _authOnboardingRequestsRoute
  '/__auth/organisations': typeof _authOrganisationsRoute
  '/__auth/playground': typeof _authPlaygroundRoute
  '/__auth/products': typeof _authProductsRoute
  '/__auth/providers': typeof _authProvidersRoute
  '/__auth/scheduled-fund-movements': typeof _authScheduledFundMovementsRoute
  '/__auth/statements': typeof _authStatementsRoute
  '/__auth/stripe-payout-queue': typeof _authStripePayoutQueueRoute
  '/__auth/term-deposits': typeof _authTermDepositsRoute
  '/__auth/transaction-import': typeof _authTransactionImportRoute
  '/__auth/transaction-monitoring': typeof _authTransactionMonitoringRouteWithChildren
  '/__auth/transactions': typeof _authTransactionsRoute
  '/__auth/transfer-groups': typeof _authTransferGroupsRoute
  '/__auth/transfers': typeof _authTransfersRoute
  '/__auth/unit-prices': typeof _authUnitPricesRoute
  '/__auth/yieldhub-sync': typeof _authYieldhubSyncRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/user-profile/{-$suffix}': typeof UserProfileChar123SuffixChar125Route
  '/__auth/': typeof _authIndexRoute
  '/user-profile/': typeof UserProfileIndexRoute
  '/__auth/asset-rules_/$ruleId': typeof _authAssetRulesRuleIdRoute
  '/__auth/assets_/$assetId': typeof _authAssetsAssetIdRoute
  '/__auth/assets_/demo-new': typeof _authAssetsDemoNewRoute
  '/__auth/assets_/new': typeof _authAssetsNewRoute
  '/__auth/beneficiary-accounts_/$beneficiaryAccountId': typeof _authBeneficiaryAccountsBeneficiaryAccountIdRoute
  '/__auth/beneficiary-accounts_/new': typeof _authBeneficiaryAccountsNewRoute
  '/__auth/calastone-orders_/$calastoneOrderId': typeof _authCalastoneOrdersCalastoneOrderIdRoute
  '/__auth/calastone-pricing-queue/$tab': typeof _authCalastonePricingQueueTabRoute
  '/__auth/cash-management-strategy_/$id': typeof _authCashManagementStrategyIdRoute
  '/__auth/cashflow-reports_/debug': typeof _authCashflowReportsDebugRoute
  '/__auth/currencycloud/rates': typeof _authCurrencycloudRatesRoute
  '/__auth/currencycloud_/$accountId': typeof _authCurrencycloudAccountIdRoute
  '/__auth/custody-accounts_/$id': typeof _authCustodyAccountsIdRoute
  '/__auth/deposits_/$depositId': typeof _authDepositsDepositIdRoute
  '/__auth/deposits_/new': typeof _authDepositsNewRoute
  '/__auth/ebury/beneficiaries': typeof _authEburyBeneficiariesRoute
  '/__auth/ebury/trades': typeof _authEburyTradesRoute
  '/__auth/events_/$eventId': typeof _authEventsEventIdRoute
  '/__auth/fund-distributions_/$fundDistributionId': typeof _authFundDistributionsFundDistributionIdRoute
  '/__auth/fund-distributions_/new': typeof _authFundDistributionsNewRoute
  '/__auth/fund-unit-orders_/$id': typeof _authFundUnitOrdersIdRoute
  '/__auth/fx-trades_/$fxTradeId': typeof _authFxTradesFxTradeIdRoute
  '/__auth/notifications_/$notificationId': typeof _authNotificationsNotificationIdRoute
  '/__auth/onboarding-requests_/new': typeof _authOnboardingRequestsNewRoute
  '/__auth/organisations_/$organisationId': typeof _authOrganisationsOrganisationIdRoute
  '/__auth/organisations_/balance-summaries': typeof _authOrganisationsBalanceSummariesRoute
  '/__auth/products_/$productId': typeof _authProductsProductIdRouteWithChildren
  '/__auth/scheduled-fund-movements_/$scheduledFundMovementId': typeof _authScheduledFundMovementsScheduledFundMovementIdRoute
  '/__auth/siss-accounts/$tab': typeof _authSissAccountsTabRoute
  '/__auth/statement-batches/$kind': typeof _authStatementBatchesKindRoute
  '/__auth/statements_/$statementId': typeof _authStatementsStatementIdRoute
  '/__auth/term-deposits_/new': typeof _authTermDepositsNewRoute
  '/__auth/transaction-import_/$fileImportId': typeof _authTransactionImportFileImportIdRoute
  '/__auth/transaction-monitoring/evaluations': typeof _authTransactionMonitoringEvaluationsRoute
  '/__auth/transaction-monitoring/findings': typeof _authTransactionMonitoringFindingsRoute
  '/__auth/transactions-queue/$tab': typeof _authTransactionsQueueTabRoute
  '/__auth/transactions_/$transactionId': typeof _authTransactionsTransactionIdRoute
  '/__auth/transactions_/batch-import': typeof _authTransactionsBatchImportRoute
  '/__auth/transactions_/new': typeof _authTransactionsNewRoute
  '/__auth/transfer-groups_/$transferGroupId': typeof _authTransferGroupsTransferGroupIdRoute
  '/__auth/transfers_/$transferId': typeof _authTransfersTransferIdRoute
  '/__auth/transfers_/new': typeof _authTransfersNewRoute
  '/__auth/yieldhub-sync_/$fileId': typeof _authYieldhubSyncFileIdRoute
  '/__auth/currencycloud/': typeof _authCurrencycloudIndexRoute
  '/__auth/ebury/': typeof _authEburyIndexRoute
  '/__auth/assets_/$assetId_/create-demo-transactions': typeof _authAssetsAssetIdCreateDemoTransactionsRoute
  '/__auth/ebury_/$clientId/beneficiaries': typeof _authEburyClientIdBeneficiariesRoute
  '/__auth/ebury_/$clientId/trades': typeof _authEburyClientIdTradesRoute
  '/__auth/ledger/accounts_/$accountId': typeof _authLedgerAccountsAccountIdRouteWithChildren
  '/__auth/ledger/transactions_/$transactionId': typeof _authLedgerTransactionsTransactionIdRouteWithChildren
  '/__auth/ledger/transactions_/new': typeof _authLedgerTransactionsNewRoute
  '/__auth/organisations_/$organisationId_/rules': typeof _authOrganisationsOrganisationIdRulesRoute
  '/__auth/products_/$productId/unit-prices': typeof _authProductsProductIdUnitPricesRoute
  '/__auth/products_/$productId_/rate-history': typeof _authProductsProductIdRateHistoryRoute
  '/__auth/statement-batches/$kind_/$statementBatchId': typeof _authStatementBatchesKindStatementBatchIdRoute
  '/__auth/transaction-monitoring_/evaluations_/$evaluationId': typeof _authTransactionMonitoringEvaluationsEvaluationIdRoute
  '/__auth/transaction-monitoring_/findings_/$findingId': typeof _authTransactionMonitoringFindingsFindingIdRoute
  '/__auth/products_/$productId/': typeof _authProductsProductIdIndexRoute
  '/__auth/currencycloud_/$accountId_/balances/$balanceId': typeof _authCurrencycloudAccountIdBalancesBalanceIdRoute
  '/__auth/ledger/accounts_/$accountId/balances': typeof _authLedgerAccountsAccountIdBalancesRoute
  '/__auth/ledger/accounts_/$accountId/entries': typeof _authLedgerAccountsAccountIdEntriesRoute
  '/__auth/ledger/transactions_/$transactionId/entries': typeof _authLedgerTransactionsTransactionIdEntriesRouteWithChildren
  '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute
  '/__auth/ledger/accounts_/$accountId/': typeof _authLedgerAccountsAccountIdIndexRoute
  '/__auth/ledger/transactions_/$transactionId/': typeof _authLedgerTransactionsTransactionIdIndexRoute
  '/__auth/ledger/transactions_/$transactionId/entries/new': typeof _authLedgerTransactionsTransactionIdEntriesNewRoute
  '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId_/mercury-onboarding': typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/sign-in'
    | '/sign-out'
    | '/$'
    | '/admin'
    | '/asset-rules'
    | '/assets'
    | '/beneficiary-accounts'
    | '/calastone-orders'
    | '/cash-management-strategies'
    | '/cashflow-reports'
    | '/cron'
    | '/currencycloud'
    | '/custody-accounts'
    | '/deposits'
    | '/design'
    | '/ebury'
    | '/events'
    | '/external-providers'
    | '/feature-flags'
    | '/fund-distributions'
    | '/fx-trades'
    | '/high-risk-jurisdictions'
    | '/jobs'
    | '/kyc-queue'
    | '/logos'
    | '/mfa-test'
    | '/non-processing-days'
    | '/onboarding-requests'
    | '/organisations'
    | '/playground'
    | '/products'
    | '/providers'
    | '/scheduled-fund-movements'
    | '/statements'
    | '/stripe-payout-queue'
    | '/term-deposits'
    | '/transaction-import'
    | '/transaction-monitoring'
    | '/transactions'
    | '/transfer-groups'
    | '/transfers'
    | '/unit-prices'
    | '/yieldhub-sync'
    | '/sign-in/$'
    | '/user-profile/{-$suffix}'
    | '/'
    | '/user-profile'
    | '/asset-rules/$ruleId'
    | '/assets/$assetId'
    | '/assets/demo-new'
    | '/assets/new'
    | '/beneficiary-accounts/$beneficiaryAccountId'
    | '/beneficiary-accounts/new'
    | '/calastone-orders/$calastoneOrderId'
    | '/calastone-pricing-queue/$tab'
    | '/cash-management-strategy/$id'
    | '/cashflow-reports/debug'
    | '/currencycloud/rates'
    | '/currencycloud/$accountId'
    | '/custody-accounts/$id'
    | '/deposits/$depositId'
    | '/deposits/new'
    | '/ebury/beneficiaries'
    | '/ebury/trades'
    | '/events/$eventId'
    | '/fund-distributions/$fundDistributionId'
    | '/fund-distributions/new'
    | '/fund-unit-orders/$id'
    | '/fx-trades/$fxTradeId'
    | '/notifications/$notificationId'
    | '/onboarding-requests/new'
    | '/organisations/$organisationId'
    | '/organisations/balance-summaries'
    | '/products/$productId'
    | '/scheduled-fund-movements/$scheduledFundMovementId'
    | '/siss-accounts/$tab'
    | '/statement-batches/$kind'
    | '/statements/$statementId'
    | '/term-deposits/new'
    | '/transaction-import/$fileImportId'
    | '/transaction-monitoring/evaluations'
    | '/transaction-monitoring/findings'
    | '/transactions-queue/$tab'
    | '/transactions/$transactionId'
    | '/transactions/batch-import'
    | '/transactions/new'
    | '/transfer-groups/$transferGroupId'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/yieldhub-sync/$fileId'
    | '/currencycloud/'
    | '/ebury/'
    | '/assets/$assetId/create-demo-transactions'
    | '/ebury/$clientId/beneficiaries'
    | '/ebury/$clientId/trades'
    | '/ledger/accounts/$accountId'
    | '/ledger/transactions/$transactionId'
    | '/ledger/transactions/new'
    | '/organisations/$organisationId/rules'
    | '/products/$productId/unit-prices'
    | '/products/$productId/rate-history'
    | '/statement-batches/$kind/$statementBatchId'
    | '/transaction-monitoring/evaluations/$evaluationId'
    | '/transaction-monitoring/findings/$findingId'
    | '/products/$productId/'
    | '/currencycloud/$accountId/balances/$balanceId'
    | '/ledger/accounts/$accountId/balances'
    | '/ledger/accounts/$accountId/entries'
    | '/ledger/transactions/$transactionId/entries'
    | '/organisations/$organisationId/business-entities/$businessEntityId'
    | '/ledger/accounts/$accountId/'
    | '/ledger/transactions/$transactionId/'
    | '/ledger/transactions/$transactionId/entries/new'
    | '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/sign-out'
    | '/$'
    | '/admin'
    | '/asset-rules'
    | '/assets'
    | '/beneficiary-accounts'
    | '/calastone-orders'
    | '/cash-management-strategies'
    | '/cashflow-reports'
    | '/cron'
    | '/custody-accounts'
    | '/deposits'
    | '/design'
    | '/events'
    | '/external-providers'
    | '/feature-flags'
    | '/fund-distributions'
    | '/fx-trades'
    | '/high-risk-jurisdictions'
    | '/jobs'
    | '/kyc-queue'
    | '/logos'
    | '/mfa-test'
    | '/non-processing-days'
    | '/onboarding-requests'
    | '/organisations'
    | '/playground'
    | '/products'
    | '/providers'
    | '/scheduled-fund-movements'
    | '/statements'
    | '/stripe-payout-queue'
    | '/term-deposits'
    | '/transaction-import'
    | '/transaction-monitoring'
    | '/transactions'
    | '/transfer-groups'
    | '/transfers'
    | '/unit-prices'
    | '/yieldhub-sync'
    | '/sign-in/$'
    | '/user-profile/{-$suffix}'
    | '/'
    | '/user-profile'
    | '/asset-rules/$ruleId'
    | '/assets/$assetId'
    | '/assets/demo-new'
    | '/assets/new'
    | '/beneficiary-accounts/$beneficiaryAccountId'
    | '/beneficiary-accounts/new'
    | '/calastone-orders/$calastoneOrderId'
    | '/calastone-pricing-queue/$tab'
    | '/cash-management-strategy/$id'
    | '/cashflow-reports/debug'
    | '/currencycloud/rates'
    | '/currencycloud/$accountId'
    | '/custody-accounts/$id'
    | '/deposits/$depositId'
    | '/deposits/new'
    | '/ebury/beneficiaries'
    | '/ebury/trades'
    | '/events/$eventId'
    | '/fund-distributions/$fundDistributionId'
    | '/fund-distributions/new'
    | '/fund-unit-orders/$id'
    | '/fx-trades/$fxTradeId'
    | '/notifications/$notificationId'
    | '/onboarding-requests/new'
    | '/organisations/$organisationId'
    | '/organisations/balance-summaries'
    | '/scheduled-fund-movements/$scheduledFundMovementId'
    | '/siss-accounts/$tab'
    | '/statement-batches/$kind'
    | '/statements/$statementId'
    | '/term-deposits/new'
    | '/transaction-import/$fileImportId'
    | '/transaction-monitoring/evaluations'
    | '/transaction-monitoring/findings'
    | '/transactions-queue/$tab'
    | '/transactions/$transactionId'
    | '/transactions/batch-import'
    | '/transactions/new'
    | '/transfer-groups/$transferGroupId'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/yieldhub-sync/$fileId'
    | '/currencycloud'
    | '/ebury'
    | '/assets/$assetId/create-demo-transactions'
    | '/ebury/$clientId/beneficiaries'
    | '/ebury/$clientId/trades'
    | '/ledger/transactions/new'
    | '/organisations/$organisationId/rules'
    | '/products/$productId/unit-prices'
    | '/products/$productId/rate-history'
    | '/statement-batches/$kind/$statementBatchId'
    | '/transaction-monitoring/evaluations/$evaluationId'
    | '/transaction-monitoring/findings/$findingId'
    | '/products/$productId'
    | '/currencycloud/$accountId/balances/$balanceId'
    | '/ledger/accounts/$accountId/balances'
    | '/ledger/accounts/$accountId/entries'
    | '/ledger/transactions/$transactionId/entries'
    | '/organisations/$organisationId/business-entities/$businessEntityId'
    | '/ledger/accounts/$accountId'
    | '/ledger/transactions/$transactionId'
    | '/ledger/transactions/$transactionId/entries/new'
    | '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding'
  id:
    | '__root__'
    | '/sign-in'
    | '/__auth'
    | '/sign-out'
    | '/__auth/$'
    | '/__auth/admin'
    | '/__auth/asset-rules'
    | '/__auth/assets'
    | '/__auth/beneficiary-accounts'
    | '/__auth/calastone-orders'
    | '/__auth/cash-management-strategies'
    | '/__auth/cashflow-reports'
    | '/__auth/cron'
    | '/__auth/currencycloud'
    | '/__auth/custody-accounts'
    | '/__auth/deposits'
    | '/__auth/design'
    | '/__auth/ebury'
    | '/__auth/events'
    | '/__auth/external-providers'
    | '/__auth/feature-flags'
    | '/__auth/fund-distributions'
    | '/__auth/fx-trades'
    | '/__auth/high-risk-jurisdictions'
    | '/__auth/jobs'
    | '/__auth/kyc-queue'
    | '/__auth/logos'
    | '/__auth/mfa-test'
    | '/__auth/non-processing-days'
    | '/__auth/onboarding-requests'
    | '/__auth/organisations'
    | '/__auth/playground'
    | '/__auth/products'
    | '/__auth/providers'
    | '/__auth/scheduled-fund-movements'
    | '/__auth/statements'
    | '/__auth/stripe-payout-queue'
    | '/__auth/term-deposits'
    | '/__auth/transaction-import'
    | '/__auth/transaction-monitoring'
    | '/__auth/transactions'
    | '/__auth/transfer-groups'
    | '/__auth/transfers'
    | '/__auth/unit-prices'
    | '/__auth/yieldhub-sync'
    | '/sign-in/$'
    | '/user-profile/{-$suffix}'
    | '/__auth/'
    | '/user-profile/'
    | '/__auth/asset-rules_/$ruleId'
    | '/__auth/assets_/$assetId'
    | '/__auth/assets_/demo-new'
    | '/__auth/assets_/new'
    | '/__auth/beneficiary-accounts_/$beneficiaryAccountId'
    | '/__auth/beneficiary-accounts_/new'
    | '/__auth/calastone-orders_/$calastoneOrderId'
    | '/__auth/calastone-pricing-queue/$tab'
    | '/__auth/cash-management-strategy_/$id'
    | '/__auth/cashflow-reports_/debug'
    | '/__auth/currencycloud/rates'
    | '/__auth/currencycloud_/$accountId'
    | '/__auth/custody-accounts_/$id'
    | '/__auth/deposits_/$depositId'
    | '/__auth/deposits_/new'
    | '/__auth/ebury/beneficiaries'
    | '/__auth/ebury/trades'
    | '/__auth/events_/$eventId'
    | '/__auth/fund-distributions_/$fundDistributionId'
    | '/__auth/fund-distributions_/new'
    | '/__auth/fund-unit-orders_/$id'
    | '/__auth/fx-trades_/$fxTradeId'
    | '/__auth/notifications_/$notificationId'
    | '/__auth/onboarding-requests_/new'
    | '/__auth/organisations_/$organisationId'
    | '/__auth/organisations_/balance-summaries'
    | '/__auth/products_/$productId'
    | '/__auth/scheduled-fund-movements_/$scheduledFundMovementId'
    | '/__auth/siss-accounts/$tab'
    | '/__auth/statement-batches/$kind'
    | '/__auth/statements_/$statementId'
    | '/__auth/term-deposits_/new'
    | '/__auth/transaction-import_/$fileImportId'
    | '/__auth/transaction-monitoring/evaluations'
    | '/__auth/transaction-monitoring/findings'
    | '/__auth/transactions-queue/$tab'
    | '/__auth/transactions_/$transactionId'
    | '/__auth/transactions_/batch-import'
    | '/__auth/transactions_/new'
    | '/__auth/transfer-groups_/$transferGroupId'
    | '/__auth/transfers_/$transferId'
    | '/__auth/transfers_/new'
    | '/__auth/yieldhub-sync_/$fileId'
    | '/__auth/currencycloud/'
    | '/__auth/ebury/'
    | '/__auth/assets_/$assetId_/create-demo-transactions'
    | '/__auth/ebury_/$clientId/beneficiaries'
    | '/__auth/ebury_/$clientId/trades'
    | '/__auth/ledger/accounts_/$accountId'
    | '/__auth/ledger/transactions_/$transactionId'
    | '/__auth/ledger/transactions_/new'
    | '/__auth/organisations_/$organisationId_/rules'
    | '/__auth/products_/$productId/unit-prices'
    | '/__auth/products_/$productId_/rate-history'
    | '/__auth/statement-batches/$kind_/$statementBatchId'
    | '/__auth/transaction-monitoring_/evaluations_/$evaluationId'
    | '/__auth/transaction-monitoring_/findings_/$findingId'
    | '/__auth/products_/$productId/'
    | '/__auth/currencycloud_/$accountId_/balances/$balanceId'
    | '/__auth/ledger/accounts_/$accountId/balances'
    | '/__auth/ledger/accounts_/$accountId/entries'
    | '/__auth/ledger/transactions_/$transactionId/entries'
    | '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId'
    | '/__auth/ledger/accounts_/$accountId/'
    | '/__auth/ledger/transactions_/$transactionId/'
    | '/__auth/ledger/transactions_/$transactionId/entries/new'
    | '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId_/mercury-onboarding'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SignInRouteRoute: typeof SignInRouteRouteWithChildren
  _authRoute: typeof _authRouteWithChildren
  SignOutRoute: typeof SignOutRoute
  UserProfileChar123SuffixChar125Route: typeof UserProfileChar123SuffixChar125Route
  UserProfileIndexRoute: typeof UserProfileIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth': {
      id: '/__auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof _authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-profile/': {
      id: '/user-profile/'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof UserProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth/': {
      id: '/__auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof _authIndexRouteImport
      parentRoute: typeof _authRoute
    }
    '/user-profile/{-$suffix}': {
      id: '/user-profile/{-$suffix}'
      path: '/user-profile/{-$suffix}'
      fullPath: '/user-profile/{-$suffix}'
      preLoaderRoute: typeof UserProfileChar123SuffixChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof SignInRouteRoute
    }
    '/__auth/yieldhub-sync': {
      id: '/__auth/yieldhub-sync'
      path: '/yieldhub-sync'
      fullPath: '/yieldhub-sync'
      preLoaderRoute: typeof _authYieldhubSyncRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/unit-prices': {
      id: '/__auth/unit-prices'
      path: '/unit-prices'
      fullPath: '/unit-prices'
      preLoaderRoute: typeof _authUnitPricesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transfers': {
      id: '/__auth/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof _authTransfersRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transfer-groups': {
      id: '/__auth/transfer-groups'
      path: '/transfer-groups'
      fullPath: '/transfer-groups'
      preLoaderRoute: typeof _authTransferGroupsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transactions': {
      id: '/__auth/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof _authTransactionsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transaction-monitoring': {
      id: '/__auth/transaction-monitoring'
      path: '/transaction-monitoring'
      fullPath: '/transaction-monitoring'
      preLoaderRoute: typeof _authTransactionMonitoringRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transaction-import': {
      id: '/__auth/transaction-import'
      path: '/transaction-import'
      fullPath: '/transaction-import'
      preLoaderRoute: typeof _authTransactionImportRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/term-deposits': {
      id: '/__auth/term-deposits'
      path: '/term-deposits'
      fullPath: '/term-deposits'
      preLoaderRoute: typeof _authTermDepositsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/stripe-payout-queue': {
      id: '/__auth/stripe-payout-queue'
      path: '/stripe-payout-queue'
      fullPath: '/stripe-payout-queue'
      preLoaderRoute: typeof _authStripePayoutQueueRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/statements': {
      id: '/__auth/statements'
      path: '/statements'
      fullPath: '/statements'
      preLoaderRoute: typeof _authStatementsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/scheduled-fund-movements': {
      id: '/__auth/scheduled-fund-movements'
      path: '/scheduled-fund-movements'
      fullPath: '/scheduled-fund-movements'
      preLoaderRoute: typeof _authScheduledFundMovementsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/providers': {
      id: '/__auth/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof _authProvidersRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/products': {
      id: '/__auth/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof _authProductsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/playground': {
      id: '/__auth/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof _authPlaygroundRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/organisations': {
      id: '/__auth/organisations'
      path: '/organisations'
      fullPath: '/organisations'
      preLoaderRoute: typeof _authOrganisationsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/onboarding-requests': {
      id: '/__auth/onboarding-requests'
      path: '/onboarding-requests'
      fullPath: '/onboarding-requests'
      preLoaderRoute: typeof _authOnboardingRequestsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/non-processing-days': {
      id: '/__auth/non-processing-days'
      path: '/non-processing-days'
      fullPath: '/non-processing-days'
      preLoaderRoute: typeof _authNonProcessingDaysRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/mfa-test': {
      id: '/__auth/mfa-test'
      path: '/mfa-test'
      fullPath: '/mfa-test'
      preLoaderRoute: typeof _authMfaTestRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/logos': {
      id: '/__auth/logos'
      path: '/logos'
      fullPath: '/logos'
      preLoaderRoute: typeof _authLogosRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/kyc-queue': {
      id: '/__auth/kyc-queue'
      path: '/kyc-queue'
      fullPath: '/kyc-queue'
      preLoaderRoute: typeof _authKycQueueRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/jobs': {
      id: '/__auth/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof _authJobsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/high-risk-jurisdictions': {
      id: '/__auth/high-risk-jurisdictions'
      path: '/high-risk-jurisdictions'
      fullPath: '/high-risk-jurisdictions'
      preLoaderRoute: typeof _authHighRiskJurisdictionsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fx-trades': {
      id: '/__auth/fx-trades'
      path: '/fx-trades'
      fullPath: '/fx-trades'
      preLoaderRoute: typeof _authFxTradesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fund-distributions': {
      id: '/__auth/fund-distributions'
      path: '/fund-distributions'
      fullPath: '/fund-distributions'
      preLoaderRoute: typeof _authFundDistributionsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/feature-flags': {
      id: '/__auth/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof _authFeatureFlagsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/external-providers': {
      id: '/__auth/external-providers'
      path: '/external-providers'
      fullPath: '/external-providers'
      preLoaderRoute: typeof _authExternalProvidersRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/events': {
      id: '/__auth/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof _authEventsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ebury': {
      id: '/__auth/ebury'
      path: '/ebury'
      fullPath: '/ebury'
      preLoaderRoute: typeof _authEburyRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/design': {
      id: '/__auth/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof _authDesignRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/deposits': {
      id: '/__auth/deposits'
      path: '/deposits'
      fullPath: '/deposits'
      preLoaderRoute: typeof _authDepositsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/custody-accounts': {
      id: '/__auth/custody-accounts'
      path: '/custody-accounts'
      fullPath: '/custody-accounts'
      preLoaderRoute: typeof _authCustodyAccountsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/currencycloud': {
      id: '/__auth/currencycloud'
      path: '/currencycloud'
      fullPath: '/currencycloud'
      preLoaderRoute: typeof _authCurrencycloudRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/cron': {
      id: '/__auth/cron'
      path: '/cron'
      fullPath: '/cron'
      preLoaderRoute: typeof _authCronRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/cashflow-reports': {
      id: '/__auth/cashflow-reports'
      path: '/cashflow-reports'
      fullPath: '/cashflow-reports'
      preLoaderRoute: typeof _authCashflowReportsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/cash-management-strategies': {
      id: '/__auth/cash-management-strategies'
      path: '/cash-management-strategies'
      fullPath: '/cash-management-strategies'
      preLoaderRoute: typeof _authCashManagementStrategiesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/calastone-orders': {
      id: '/__auth/calastone-orders'
      path: '/calastone-orders'
      fullPath: '/calastone-orders'
      preLoaderRoute: typeof _authCalastoneOrdersRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/beneficiary-accounts': {
      id: '/__auth/beneficiary-accounts'
      path: '/beneficiary-accounts'
      fullPath: '/beneficiary-accounts'
      preLoaderRoute: typeof _authBeneficiaryAccountsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/assets': {
      id: '/__auth/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof _authAssetsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/asset-rules': {
      id: '/__auth/asset-rules'
      path: '/asset-rules'
      fullPath: '/asset-rules'
      preLoaderRoute: typeof _authAssetRulesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/admin': {
      id: '/__auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof _authAdminRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/$': {
      id: '/__auth/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof _authSplatRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ebury/': {
      id: '/__auth/ebury/'
      path: '/'
      fullPath: '/ebury/'
      preLoaderRoute: typeof _authEburyIndexRouteImport
      parentRoute: typeof _authEburyRoute
    }
    '/__auth/currencycloud/': {
      id: '/__auth/currencycloud/'
      path: '/'
      fullPath: '/currencycloud/'
      preLoaderRoute: typeof _authCurrencycloudIndexRouteImport
      parentRoute: typeof _authCurrencycloudRoute
    }
    '/__auth/yieldhub-sync_/$fileId': {
      id: '/__auth/yieldhub-sync_/$fileId'
      path: '/yieldhub-sync/$fileId'
      fullPath: '/yieldhub-sync/$fileId'
      preLoaderRoute: typeof _authYieldhubSyncFileIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transfers_/new': {
      id: '/__auth/transfers_/new'
      path: '/transfers/new'
      fullPath: '/transfers/new'
      preLoaderRoute: typeof _authTransfersNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transfers_/$transferId': {
      id: '/__auth/transfers_/$transferId'
      path: '/transfers/$transferId'
      fullPath: '/transfers/$transferId'
      preLoaderRoute: typeof _authTransfersTransferIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transfer-groups_/$transferGroupId': {
      id: '/__auth/transfer-groups_/$transferGroupId'
      path: '/transfer-groups/$transferGroupId'
      fullPath: '/transfer-groups/$transferGroupId'
      preLoaderRoute: typeof _authTransferGroupsTransferGroupIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transactions_/new': {
      id: '/__auth/transactions_/new'
      path: '/transactions/new'
      fullPath: '/transactions/new'
      preLoaderRoute: typeof _authTransactionsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transactions_/batch-import': {
      id: '/__auth/transactions_/batch-import'
      path: '/transactions/batch-import'
      fullPath: '/transactions/batch-import'
      preLoaderRoute: typeof _authTransactionsBatchImportRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transactions_/$transactionId': {
      id: '/__auth/transactions_/$transactionId'
      path: '/transactions/$transactionId'
      fullPath: '/transactions/$transactionId'
      preLoaderRoute: typeof _authTransactionsTransactionIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transactions-queue/$tab': {
      id: '/__auth/transactions-queue/$tab'
      path: '/transactions-queue/$tab'
      fullPath: '/transactions-queue/$tab'
      preLoaderRoute: typeof _authTransactionsQueueTabRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transaction-monitoring/findings': {
      id: '/__auth/transaction-monitoring/findings'
      path: '/findings'
      fullPath: '/transaction-monitoring/findings'
      preLoaderRoute: typeof _authTransactionMonitoringFindingsRouteImport
      parentRoute: typeof _authTransactionMonitoringRoute
    }
    '/__auth/transaction-monitoring/evaluations': {
      id: '/__auth/transaction-monitoring/evaluations'
      path: '/evaluations'
      fullPath: '/transaction-monitoring/evaluations'
      preLoaderRoute: typeof _authTransactionMonitoringEvaluationsRouteImport
      parentRoute: typeof _authTransactionMonitoringRoute
    }
    '/__auth/transaction-import_/$fileImportId': {
      id: '/__auth/transaction-import_/$fileImportId'
      path: '/transaction-import/$fileImportId'
      fullPath: '/transaction-import/$fileImportId'
      preLoaderRoute: typeof _authTransactionImportFileImportIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/term-deposits_/new': {
      id: '/__auth/term-deposits_/new'
      path: '/term-deposits/new'
      fullPath: '/term-deposits/new'
      preLoaderRoute: typeof _authTermDepositsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/statements_/$statementId': {
      id: '/__auth/statements_/$statementId'
      path: '/statements/$statementId'
      fullPath: '/statements/$statementId'
      preLoaderRoute: typeof _authStatementsStatementIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/statement-batches/$kind': {
      id: '/__auth/statement-batches/$kind'
      path: '/statement-batches/$kind'
      fullPath: '/statement-batches/$kind'
      preLoaderRoute: typeof _authStatementBatchesKindRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/siss-accounts/$tab': {
      id: '/__auth/siss-accounts/$tab'
      path: '/siss-accounts/$tab'
      fullPath: '/siss-accounts/$tab'
      preLoaderRoute: typeof _authSissAccountsTabRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/scheduled-fund-movements_/$scheduledFundMovementId': {
      id: '/__auth/scheduled-fund-movements_/$scheduledFundMovementId'
      path: '/scheduled-fund-movements/$scheduledFundMovementId'
      fullPath: '/scheduled-fund-movements/$scheduledFundMovementId'
      preLoaderRoute: typeof _authScheduledFundMovementsScheduledFundMovementIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/products_/$productId': {
      id: '/__auth/products_/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof _authProductsProductIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/organisations_/balance-summaries': {
      id: '/__auth/organisations_/balance-summaries'
      path: '/organisations/balance-summaries'
      fullPath: '/organisations/balance-summaries'
      preLoaderRoute: typeof _authOrganisationsBalanceSummariesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/organisations_/$organisationId': {
      id: '/__auth/organisations_/$organisationId'
      path: '/organisations/$organisationId'
      fullPath: '/organisations/$organisationId'
      preLoaderRoute: typeof _authOrganisationsOrganisationIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/onboarding-requests_/new': {
      id: '/__auth/onboarding-requests_/new'
      path: '/onboarding-requests/new'
      fullPath: '/onboarding-requests/new'
      preLoaderRoute: typeof _authOnboardingRequestsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/notifications_/$notificationId': {
      id: '/__auth/notifications_/$notificationId'
      path: '/notifications/$notificationId'
      fullPath: '/notifications/$notificationId'
      preLoaderRoute: typeof _authNotificationsNotificationIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fx-trades_/$fxTradeId': {
      id: '/__auth/fx-trades_/$fxTradeId'
      path: '/fx-trades/$fxTradeId'
      fullPath: '/fx-trades/$fxTradeId'
      preLoaderRoute: typeof _authFxTradesFxTradeIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fund-unit-orders_/$id': {
      id: '/__auth/fund-unit-orders_/$id'
      path: '/fund-unit-orders/$id'
      fullPath: '/fund-unit-orders/$id'
      preLoaderRoute: typeof _authFundUnitOrdersIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fund-distributions_/new': {
      id: '/__auth/fund-distributions_/new'
      path: '/fund-distributions/new'
      fullPath: '/fund-distributions/new'
      preLoaderRoute: typeof _authFundDistributionsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/fund-distributions_/$fundDistributionId': {
      id: '/__auth/fund-distributions_/$fundDistributionId'
      path: '/fund-distributions/$fundDistributionId'
      fullPath: '/fund-distributions/$fundDistributionId'
      preLoaderRoute: typeof _authFundDistributionsFundDistributionIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/events_/$eventId': {
      id: '/__auth/events_/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof _authEventsEventIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ebury/trades': {
      id: '/__auth/ebury/trades'
      path: '/trades'
      fullPath: '/ebury/trades'
      preLoaderRoute: typeof _authEburyTradesRouteImport
      parentRoute: typeof _authEburyRoute
    }
    '/__auth/ebury/beneficiaries': {
      id: '/__auth/ebury/beneficiaries'
      path: '/beneficiaries'
      fullPath: '/ebury/beneficiaries'
      preLoaderRoute: typeof _authEburyBeneficiariesRouteImport
      parentRoute: typeof _authEburyRoute
    }
    '/__auth/deposits_/new': {
      id: '/__auth/deposits_/new'
      path: '/deposits/new'
      fullPath: '/deposits/new'
      preLoaderRoute: typeof _authDepositsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/deposits_/$depositId': {
      id: '/__auth/deposits_/$depositId'
      path: '/deposits/$depositId'
      fullPath: '/deposits/$depositId'
      preLoaderRoute: typeof _authDepositsDepositIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/custody-accounts_/$id': {
      id: '/__auth/custody-accounts_/$id'
      path: '/custody-accounts/$id'
      fullPath: '/custody-accounts/$id'
      preLoaderRoute: typeof _authCustodyAccountsIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/currencycloud_/$accountId': {
      id: '/__auth/currencycloud_/$accountId'
      path: '/currencycloud/$accountId'
      fullPath: '/currencycloud/$accountId'
      preLoaderRoute: typeof _authCurrencycloudAccountIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/currencycloud/rates': {
      id: '/__auth/currencycloud/rates'
      path: '/rates'
      fullPath: '/currencycloud/rates'
      preLoaderRoute: typeof _authCurrencycloudRatesRouteImport
      parentRoute: typeof _authCurrencycloudRoute
    }
    '/__auth/cashflow-reports_/debug': {
      id: '/__auth/cashflow-reports_/debug'
      path: '/cashflow-reports/debug'
      fullPath: '/cashflow-reports/debug'
      preLoaderRoute: typeof _authCashflowReportsDebugRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/cash-management-strategy_/$id': {
      id: '/__auth/cash-management-strategy_/$id'
      path: '/cash-management-strategy/$id'
      fullPath: '/cash-management-strategy/$id'
      preLoaderRoute: typeof _authCashManagementStrategyIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/calastone-pricing-queue/$tab': {
      id: '/__auth/calastone-pricing-queue/$tab'
      path: '/calastone-pricing-queue/$tab'
      fullPath: '/calastone-pricing-queue/$tab'
      preLoaderRoute: typeof _authCalastonePricingQueueTabRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/calastone-orders_/$calastoneOrderId': {
      id: '/__auth/calastone-orders_/$calastoneOrderId'
      path: '/calastone-orders/$calastoneOrderId'
      fullPath: '/calastone-orders/$calastoneOrderId'
      preLoaderRoute: typeof _authCalastoneOrdersCalastoneOrderIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/beneficiary-accounts_/new': {
      id: '/__auth/beneficiary-accounts_/new'
      path: '/beneficiary-accounts/new'
      fullPath: '/beneficiary-accounts/new'
      preLoaderRoute: typeof _authBeneficiaryAccountsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/beneficiary-accounts_/$beneficiaryAccountId': {
      id: '/__auth/beneficiary-accounts_/$beneficiaryAccountId'
      path: '/beneficiary-accounts/$beneficiaryAccountId'
      fullPath: '/beneficiary-accounts/$beneficiaryAccountId'
      preLoaderRoute: typeof _authBeneficiaryAccountsBeneficiaryAccountIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/assets_/new': {
      id: '/__auth/assets_/new'
      path: '/assets/new'
      fullPath: '/assets/new'
      preLoaderRoute: typeof _authAssetsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/assets_/demo-new': {
      id: '/__auth/assets_/demo-new'
      path: '/assets/demo-new'
      fullPath: '/assets/demo-new'
      preLoaderRoute: typeof _authAssetsDemoNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/assets_/$assetId': {
      id: '/__auth/assets_/$assetId'
      path: '/assets/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof _authAssetsAssetIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/asset-rules_/$ruleId': {
      id: '/__auth/asset-rules_/$ruleId'
      path: '/asset-rules/$ruleId'
      fullPath: '/asset-rules/$ruleId'
      preLoaderRoute: typeof _authAssetRulesRuleIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/products_/$productId/': {
      id: '/__auth/products_/$productId/'
      path: '/'
      fullPath: '/products/$productId/'
      preLoaderRoute: typeof _authProductsProductIdIndexRouteImport
      parentRoute: typeof _authProductsProductIdRoute
    }
    '/__auth/transaction-monitoring_/findings_/$findingId': {
      id: '/__auth/transaction-monitoring_/findings_/$findingId'
      path: '/transaction-monitoring/findings/$findingId'
      fullPath: '/transaction-monitoring/findings/$findingId'
      preLoaderRoute: typeof _authTransactionMonitoringFindingsFindingIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/transaction-monitoring_/evaluations_/$evaluationId': {
      id: '/__auth/transaction-monitoring_/evaluations_/$evaluationId'
      path: '/transaction-monitoring/evaluations/$evaluationId'
      fullPath: '/transaction-monitoring/evaluations/$evaluationId'
      preLoaderRoute: typeof _authTransactionMonitoringEvaluationsEvaluationIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/statement-batches/$kind_/$statementBatchId': {
      id: '/__auth/statement-batches/$kind_/$statementBatchId'
      path: '/statement-batches/$kind/$statementBatchId'
      fullPath: '/statement-batches/$kind/$statementBatchId'
      preLoaderRoute: typeof _authStatementBatchesKindStatementBatchIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/products_/$productId_/rate-history': {
      id: '/__auth/products_/$productId_/rate-history'
      path: '/products/$productId/rate-history'
      fullPath: '/products/$productId/rate-history'
      preLoaderRoute: typeof _authProductsProductIdRateHistoryRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/products_/$productId/unit-prices': {
      id: '/__auth/products_/$productId/unit-prices'
      path: '/unit-prices'
      fullPath: '/products/$productId/unit-prices'
      preLoaderRoute: typeof _authProductsProductIdUnitPricesRouteImport
      parentRoute: typeof _authProductsProductIdRoute
    }
    '/__auth/organisations_/$organisationId_/rules': {
      id: '/__auth/organisations_/$organisationId_/rules'
      path: '/organisations/$organisationId/rules'
      fullPath: '/organisations/$organisationId/rules'
      preLoaderRoute: typeof _authOrganisationsOrganisationIdRulesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/transactions_/new': {
      id: '/__auth/ledger/transactions_/new'
      path: '/ledger/transactions/new'
      fullPath: '/ledger/transactions/new'
      preLoaderRoute: typeof _authLedgerTransactionsNewRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/transactions_/$transactionId': {
      id: '/__auth/ledger/transactions_/$transactionId'
      path: '/ledger/transactions/$transactionId'
      fullPath: '/ledger/transactions/$transactionId'
      preLoaderRoute: typeof _authLedgerTransactionsTransactionIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/accounts_/$accountId': {
      id: '/__auth/ledger/accounts_/$accountId'
      path: '/ledger/accounts/$accountId'
      fullPath: '/ledger/accounts/$accountId'
      preLoaderRoute: typeof _authLedgerAccountsAccountIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ebury_/$clientId/trades': {
      id: '/__auth/ebury_/$clientId/trades'
      path: '/ebury/$clientId/trades'
      fullPath: '/ebury/$clientId/trades'
      preLoaderRoute: typeof _authEburyClientIdTradesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ebury_/$clientId/beneficiaries': {
      id: '/__auth/ebury_/$clientId/beneficiaries'
      path: '/ebury/$clientId/beneficiaries'
      fullPath: '/ebury/$clientId/beneficiaries'
      preLoaderRoute: typeof _authEburyClientIdBeneficiariesRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/assets_/$assetId_/create-demo-transactions': {
      id: '/__auth/assets_/$assetId_/create-demo-transactions'
      path: '/assets/$assetId/create-demo-transactions'
      fullPath: '/assets/$assetId/create-demo-transactions'
      preLoaderRoute: typeof _authAssetsAssetIdCreateDemoTransactionsRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/transactions_/$transactionId/': {
      id: '/__auth/ledger/transactions_/$transactionId/'
      path: '/'
      fullPath: '/ledger/transactions/$transactionId/'
      preLoaderRoute: typeof _authLedgerTransactionsTransactionIdIndexRouteImport
      parentRoute: typeof _authLedgerTransactionsTransactionIdRoute
    }
    '/__auth/ledger/accounts_/$accountId/': {
      id: '/__auth/ledger/accounts_/$accountId/'
      path: '/'
      fullPath: '/ledger/accounts/$accountId/'
      preLoaderRoute: typeof _authLedgerAccountsAccountIdIndexRouteImport
      parentRoute: typeof _authLedgerAccountsAccountIdRoute
    }
    '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId': {
      id: '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId'
      path: '/organisations/$organisationId/business-entities/$businessEntityId'
      fullPath: '/organisations/$organisationId/business-entities/$businessEntityId'
      preLoaderRoute: typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/transactions_/$transactionId/entries': {
      id: '/__auth/ledger/transactions_/$transactionId/entries'
      path: '/entries'
      fullPath: '/ledger/transactions/$transactionId/entries'
      preLoaderRoute: typeof _authLedgerTransactionsTransactionIdEntriesRouteImport
      parentRoute: typeof _authLedgerTransactionsTransactionIdRoute
    }
    '/__auth/ledger/accounts_/$accountId/entries': {
      id: '/__auth/ledger/accounts_/$accountId/entries'
      path: '/entries'
      fullPath: '/ledger/accounts/$accountId/entries'
      preLoaderRoute: typeof _authLedgerAccountsAccountIdEntriesRouteImport
      parentRoute: typeof _authLedgerAccountsAccountIdRoute
    }
    '/__auth/ledger/accounts_/$accountId/balances': {
      id: '/__auth/ledger/accounts_/$accountId/balances'
      path: '/balances'
      fullPath: '/ledger/accounts/$accountId/balances'
      preLoaderRoute: typeof _authLedgerAccountsAccountIdBalancesRouteImport
      parentRoute: typeof _authLedgerAccountsAccountIdRoute
    }
    '/__auth/currencycloud_/$accountId_/balances/$balanceId': {
      id: '/__auth/currencycloud_/$accountId_/balances/$balanceId'
      path: '/currencycloud/$accountId/balances/$balanceId'
      fullPath: '/currencycloud/$accountId/balances/$balanceId'
      preLoaderRoute: typeof _authCurrencycloudAccountIdBalancesBalanceIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId_/mercury-onboarding': {
      id: '/__auth/organisations_/$organisationId_/business-entities_/$businessEntityId_/mercury-onboarding'
      path: '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding'
      fullPath: '/organisations/$organisationId/business-entities/$businessEntityId/mercury-onboarding'
      preLoaderRoute: typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/ledger/transactions_/$transactionId/entries/new': {
      id: '/__auth/ledger/transactions_/$transactionId/entries/new'
      path: '/new'
      fullPath: '/ledger/transactions/$transactionId/entries/new'
      preLoaderRoute: typeof _authLedgerTransactionsTransactionIdEntriesNewRouteImport
      parentRoute: typeof _authLedgerTransactionsTransactionIdEntriesRoute
    }
  }
}

interface SignInRouteRouteChildren {
  SignInSplatRoute: typeof SignInSplatRoute
}

const SignInRouteRouteChildren: SignInRouteRouteChildren = {
  SignInSplatRoute: SignInSplatRoute,
}

const SignInRouteRouteWithChildren = SignInRouteRoute._addFileChildren(
  SignInRouteRouteChildren,
)

interface _authCurrencycloudRouteChildren {
  _authCurrencycloudRatesRoute: typeof _authCurrencycloudRatesRoute
  _authCurrencycloudIndexRoute: typeof _authCurrencycloudIndexRoute
}

const _authCurrencycloudRouteChildren: _authCurrencycloudRouteChildren = {
  _authCurrencycloudRatesRoute: _authCurrencycloudRatesRoute,
  _authCurrencycloudIndexRoute: _authCurrencycloudIndexRoute,
}

const _authCurrencycloudRouteWithChildren =
  _authCurrencycloudRoute._addFileChildren(_authCurrencycloudRouteChildren)

interface _authEburyRouteChildren {
  _authEburyBeneficiariesRoute: typeof _authEburyBeneficiariesRoute
  _authEburyTradesRoute: typeof _authEburyTradesRoute
  _authEburyIndexRoute: typeof _authEburyIndexRoute
}

const _authEburyRouteChildren: _authEburyRouteChildren = {
  _authEburyBeneficiariesRoute: _authEburyBeneficiariesRoute,
  _authEburyTradesRoute: _authEburyTradesRoute,
  _authEburyIndexRoute: _authEburyIndexRoute,
}

const _authEburyRouteWithChildren = _authEburyRoute._addFileChildren(
  _authEburyRouteChildren,
)

interface _authTransactionMonitoringRouteChildren {
  _authTransactionMonitoringEvaluationsRoute: typeof _authTransactionMonitoringEvaluationsRoute
  _authTransactionMonitoringFindingsRoute: typeof _authTransactionMonitoringFindingsRoute
}

const _authTransactionMonitoringRouteChildren: _authTransactionMonitoringRouteChildren =
  {
    _authTransactionMonitoringEvaluationsRoute:
      _authTransactionMonitoringEvaluationsRoute,
    _authTransactionMonitoringFindingsRoute:
      _authTransactionMonitoringFindingsRoute,
  }

const _authTransactionMonitoringRouteWithChildren =
  _authTransactionMonitoringRoute._addFileChildren(
    _authTransactionMonitoringRouteChildren,
  )

interface _authProductsProductIdRouteChildren {
  _authProductsProductIdUnitPricesRoute: typeof _authProductsProductIdUnitPricesRoute
  _authProductsProductIdIndexRoute: typeof _authProductsProductIdIndexRoute
}

const _authProductsProductIdRouteChildren: _authProductsProductIdRouteChildren =
  {
    _authProductsProductIdUnitPricesRoute:
      _authProductsProductIdUnitPricesRoute,
    _authProductsProductIdIndexRoute: _authProductsProductIdIndexRoute,
  }

const _authProductsProductIdRouteWithChildren =
  _authProductsProductIdRoute._addFileChildren(
    _authProductsProductIdRouteChildren,
  )

interface _authLedgerAccountsAccountIdRouteChildren {
  _authLedgerAccountsAccountIdBalancesRoute: typeof _authLedgerAccountsAccountIdBalancesRoute
  _authLedgerAccountsAccountIdEntriesRoute: typeof _authLedgerAccountsAccountIdEntriesRoute
  _authLedgerAccountsAccountIdIndexRoute: typeof _authLedgerAccountsAccountIdIndexRoute
}

const _authLedgerAccountsAccountIdRouteChildren: _authLedgerAccountsAccountIdRouteChildren =
  {
    _authLedgerAccountsAccountIdBalancesRoute:
      _authLedgerAccountsAccountIdBalancesRoute,
    _authLedgerAccountsAccountIdEntriesRoute:
      _authLedgerAccountsAccountIdEntriesRoute,
    _authLedgerAccountsAccountIdIndexRoute:
      _authLedgerAccountsAccountIdIndexRoute,
  }

const _authLedgerAccountsAccountIdRouteWithChildren =
  _authLedgerAccountsAccountIdRoute._addFileChildren(
    _authLedgerAccountsAccountIdRouteChildren,
  )

interface _authLedgerTransactionsTransactionIdEntriesRouteChildren {
  _authLedgerTransactionsTransactionIdEntriesNewRoute: typeof _authLedgerTransactionsTransactionIdEntriesNewRoute
}

const _authLedgerTransactionsTransactionIdEntriesRouteChildren: _authLedgerTransactionsTransactionIdEntriesRouteChildren =
  {
    _authLedgerTransactionsTransactionIdEntriesNewRoute:
      _authLedgerTransactionsTransactionIdEntriesNewRoute,
  }

const _authLedgerTransactionsTransactionIdEntriesRouteWithChildren =
  _authLedgerTransactionsTransactionIdEntriesRoute._addFileChildren(
    _authLedgerTransactionsTransactionIdEntriesRouteChildren,
  )

interface _authLedgerTransactionsTransactionIdRouteChildren {
  _authLedgerTransactionsTransactionIdEntriesRoute: typeof _authLedgerTransactionsTransactionIdEntriesRouteWithChildren
  _authLedgerTransactionsTransactionIdIndexRoute: typeof _authLedgerTransactionsTransactionIdIndexRoute
}

const _authLedgerTransactionsTransactionIdRouteChildren: _authLedgerTransactionsTransactionIdRouteChildren =
  {
    _authLedgerTransactionsTransactionIdEntriesRoute:
      _authLedgerTransactionsTransactionIdEntriesRouteWithChildren,
    _authLedgerTransactionsTransactionIdIndexRoute:
      _authLedgerTransactionsTransactionIdIndexRoute,
  }

const _authLedgerTransactionsTransactionIdRouteWithChildren =
  _authLedgerTransactionsTransactionIdRoute._addFileChildren(
    _authLedgerTransactionsTransactionIdRouteChildren,
  )

interface _authRouteChildren {
  _authSplatRoute: typeof _authSplatRoute
  _authAdminRoute: typeof _authAdminRoute
  _authAssetRulesRoute: typeof _authAssetRulesRoute
  _authAssetsRoute: typeof _authAssetsRoute
  _authBeneficiaryAccountsRoute: typeof _authBeneficiaryAccountsRoute
  _authCalastoneOrdersRoute: typeof _authCalastoneOrdersRoute
  _authCashManagementStrategiesRoute: typeof _authCashManagementStrategiesRoute
  _authCashflowReportsRoute: typeof _authCashflowReportsRoute
  _authCronRoute: typeof _authCronRoute
  _authCurrencycloudRoute: typeof _authCurrencycloudRouteWithChildren
  _authCustodyAccountsRoute: typeof _authCustodyAccountsRoute
  _authDepositsRoute: typeof _authDepositsRoute
  _authDesignRoute: typeof _authDesignRoute
  _authEburyRoute: typeof _authEburyRouteWithChildren
  _authEventsRoute: typeof _authEventsRoute
  _authExternalProvidersRoute: typeof _authExternalProvidersRoute
  _authFeatureFlagsRoute: typeof _authFeatureFlagsRoute
  _authFundDistributionsRoute: typeof _authFundDistributionsRoute
  _authFxTradesRoute: typeof _authFxTradesRoute
  _authHighRiskJurisdictionsRoute: typeof _authHighRiskJurisdictionsRoute
  _authJobsRoute: typeof _authJobsRoute
  _authKycQueueRoute: typeof _authKycQueueRoute
  _authLogosRoute: typeof _authLogosRoute
  _authMfaTestRoute: typeof _authMfaTestRoute
  _authNonProcessingDaysRoute: typeof _authNonProcessingDaysRoute
  _authOnboardingRequestsRoute: typeof _authOnboardingRequestsRoute
  _authOrganisationsRoute: typeof _authOrganisationsRoute
  _authPlaygroundRoute: typeof _authPlaygroundRoute
  _authProductsRoute: typeof _authProductsRoute
  _authProvidersRoute: typeof _authProvidersRoute
  _authScheduledFundMovementsRoute: typeof _authScheduledFundMovementsRoute
  _authStatementsRoute: typeof _authStatementsRoute
  _authStripePayoutQueueRoute: typeof _authStripePayoutQueueRoute
  _authTermDepositsRoute: typeof _authTermDepositsRoute
  _authTransactionImportRoute: typeof _authTransactionImportRoute
  _authTransactionMonitoringRoute: typeof _authTransactionMonitoringRouteWithChildren
  _authTransactionsRoute: typeof _authTransactionsRoute
  _authTransferGroupsRoute: typeof _authTransferGroupsRoute
  _authTransfersRoute: typeof _authTransfersRoute
  _authUnitPricesRoute: typeof _authUnitPricesRoute
  _authYieldhubSyncRoute: typeof _authYieldhubSyncRoute
  _authIndexRoute: typeof _authIndexRoute
  _authAssetRulesRuleIdRoute: typeof _authAssetRulesRuleIdRoute
  _authAssetsAssetIdRoute: typeof _authAssetsAssetIdRoute
  _authAssetsDemoNewRoute: typeof _authAssetsDemoNewRoute
  _authAssetsNewRoute: typeof _authAssetsNewRoute
  _authBeneficiaryAccountsBeneficiaryAccountIdRoute: typeof _authBeneficiaryAccountsBeneficiaryAccountIdRoute
  _authBeneficiaryAccountsNewRoute: typeof _authBeneficiaryAccountsNewRoute
  _authCalastoneOrdersCalastoneOrderIdRoute: typeof _authCalastoneOrdersCalastoneOrderIdRoute
  _authCalastonePricingQueueTabRoute: typeof _authCalastonePricingQueueTabRoute
  _authCashManagementStrategyIdRoute: typeof _authCashManagementStrategyIdRoute
  _authCashflowReportsDebugRoute: typeof _authCashflowReportsDebugRoute
  _authCurrencycloudAccountIdRoute: typeof _authCurrencycloudAccountIdRoute
  _authCustodyAccountsIdRoute: typeof _authCustodyAccountsIdRoute
  _authDepositsDepositIdRoute: typeof _authDepositsDepositIdRoute
  _authDepositsNewRoute: typeof _authDepositsNewRoute
  _authEventsEventIdRoute: typeof _authEventsEventIdRoute
  _authFundDistributionsFundDistributionIdRoute: typeof _authFundDistributionsFundDistributionIdRoute
  _authFundDistributionsNewRoute: typeof _authFundDistributionsNewRoute
  _authFundUnitOrdersIdRoute: typeof _authFundUnitOrdersIdRoute
  _authFxTradesFxTradeIdRoute: typeof _authFxTradesFxTradeIdRoute
  _authNotificationsNotificationIdRoute: typeof _authNotificationsNotificationIdRoute
  _authOnboardingRequestsNewRoute: typeof _authOnboardingRequestsNewRoute
  _authOrganisationsOrganisationIdRoute: typeof _authOrganisationsOrganisationIdRoute
  _authOrganisationsBalanceSummariesRoute: typeof _authOrganisationsBalanceSummariesRoute
  _authProductsProductIdRoute: typeof _authProductsProductIdRouteWithChildren
  _authScheduledFundMovementsScheduledFundMovementIdRoute: typeof _authScheduledFundMovementsScheduledFundMovementIdRoute
  _authSissAccountsTabRoute: typeof _authSissAccountsTabRoute
  _authStatementBatchesKindRoute: typeof _authStatementBatchesKindRoute
  _authStatementsStatementIdRoute: typeof _authStatementsStatementIdRoute
  _authTermDepositsNewRoute: typeof _authTermDepositsNewRoute
  _authTransactionImportFileImportIdRoute: typeof _authTransactionImportFileImportIdRoute
  _authTransactionsQueueTabRoute: typeof _authTransactionsQueueTabRoute
  _authTransactionsTransactionIdRoute: typeof _authTransactionsTransactionIdRoute
  _authTransactionsBatchImportRoute: typeof _authTransactionsBatchImportRoute
  _authTransactionsNewRoute: typeof _authTransactionsNewRoute
  _authTransferGroupsTransferGroupIdRoute: typeof _authTransferGroupsTransferGroupIdRoute
  _authTransfersTransferIdRoute: typeof _authTransfersTransferIdRoute
  _authTransfersNewRoute: typeof _authTransfersNewRoute
  _authYieldhubSyncFileIdRoute: typeof _authYieldhubSyncFileIdRoute
  _authAssetsAssetIdCreateDemoTransactionsRoute: typeof _authAssetsAssetIdCreateDemoTransactionsRoute
  _authEburyClientIdBeneficiariesRoute: typeof _authEburyClientIdBeneficiariesRoute
  _authEburyClientIdTradesRoute: typeof _authEburyClientIdTradesRoute
  _authLedgerAccountsAccountIdRoute: typeof _authLedgerAccountsAccountIdRouteWithChildren
  _authLedgerTransactionsTransactionIdRoute: typeof _authLedgerTransactionsTransactionIdRouteWithChildren
  _authLedgerTransactionsNewRoute: typeof _authLedgerTransactionsNewRoute
  _authOrganisationsOrganisationIdRulesRoute: typeof _authOrganisationsOrganisationIdRulesRoute
  _authProductsProductIdRateHistoryRoute: typeof _authProductsProductIdRateHistoryRoute
  _authStatementBatchesKindStatementBatchIdRoute: typeof _authStatementBatchesKindStatementBatchIdRoute
  _authTransactionMonitoringEvaluationsEvaluationIdRoute: typeof _authTransactionMonitoringEvaluationsEvaluationIdRoute
  _authTransactionMonitoringFindingsFindingIdRoute: typeof _authTransactionMonitoringFindingsFindingIdRoute
  _authCurrencycloudAccountIdBalancesBalanceIdRoute: typeof _authCurrencycloudAccountIdBalancesBalanceIdRoute
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute: typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute: typeof _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute
}

const _authRouteChildren: _authRouteChildren = {
  _authSplatRoute: _authSplatRoute,
  _authAdminRoute: _authAdminRoute,
  _authAssetRulesRoute: _authAssetRulesRoute,
  _authAssetsRoute: _authAssetsRoute,
  _authBeneficiaryAccountsRoute: _authBeneficiaryAccountsRoute,
  _authCalastoneOrdersRoute: _authCalastoneOrdersRoute,
  _authCashManagementStrategiesRoute: _authCashManagementStrategiesRoute,
  _authCashflowReportsRoute: _authCashflowReportsRoute,
  _authCronRoute: _authCronRoute,
  _authCurrencycloudRoute: _authCurrencycloudRouteWithChildren,
  _authCustodyAccountsRoute: _authCustodyAccountsRoute,
  _authDepositsRoute: _authDepositsRoute,
  _authDesignRoute: _authDesignRoute,
  _authEburyRoute: _authEburyRouteWithChildren,
  _authEventsRoute: _authEventsRoute,
  _authExternalProvidersRoute: _authExternalProvidersRoute,
  _authFeatureFlagsRoute: _authFeatureFlagsRoute,
  _authFundDistributionsRoute: _authFundDistributionsRoute,
  _authFxTradesRoute: _authFxTradesRoute,
  _authHighRiskJurisdictionsRoute: _authHighRiskJurisdictionsRoute,
  _authJobsRoute: _authJobsRoute,
  _authKycQueueRoute: _authKycQueueRoute,
  _authLogosRoute: _authLogosRoute,
  _authMfaTestRoute: _authMfaTestRoute,
  _authNonProcessingDaysRoute: _authNonProcessingDaysRoute,
  _authOnboardingRequestsRoute: _authOnboardingRequestsRoute,
  _authOrganisationsRoute: _authOrganisationsRoute,
  _authPlaygroundRoute: _authPlaygroundRoute,
  _authProductsRoute: _authProductsRoute,
  _authProvidersRoute: _authProvidersRoute,
  _authScheduledFundMovementsRoute: _authScheduledFundMovementsRoute,
  _authStatementsRoute: _authStatementsRoute,
  _authStripePayoutQueueRoute: _authStripePayoutQueueRoute,
  _authTermDepositsRoute: _authTermDepositsRoute,
  _authTransactionImportRoute: _authTransactionImportRoute,
  _authTransactionMonitoringRoute: _authTransactionMonitoringRouteWithChildren,
  _authTransactionsRoute: _authTransactionsRoute,
  _authTransferGroupsRoute: _authTransferGroupsRoute,
  _authTransfersRoute: _authTransfersRoute,
  _authUnitPricesRoute: _authUnitPricesRoute,
  _authYieldhubSyncRoute: _authYieldhubSyncRoute,
  _authIndexRoute: _authIndexRoute,
  _authAssetRulesRuleIdRoute: _authAssetRulesRuleIdRoute,
  _authAssetsAssetIdRoute: _authAssetsAssetIdRoute,
  _authAssetsDemoNewRoute: _authAssetsDemoNewRoute,
  _authAssetsNewRoute: _authAssetsNewRoute,
  _authBeneficiaryAccountsBeneficiaryAccountIdRoute:
    _authBeneficiaryAccountsBeneficiaryAccountIdRoute,
  _authBeneficiaryAccountsNewRoute: _authBeneficiaryAccountsNewRoute,
  _authCalastoneOrdersCalastoneOrderIdRoute:
    _authCalastoneOrdersCalastoneOrderIdRoute,
  _authCalastonePricingQueueTabRoute: _authCalastonePricingQueueTabRoute,
  _authCashManagementStrategyIdRoute: _authCashManagementStrategyIdRoute,
  _authCashflowReportsDebugRoute: _authCashflowReportsDebugRoute,
  _authCurrencycloudAccountIdRoute: _authCurrencycloudAccountIdRoute,
  _authCustodyAccountsIdRoute: _authCustodyAccountsIdRoute,
  _authDepositsDepositIdRoute: _authDepositsDepositIdRoute,
  _authDepositsNewRoute: _authDepositsNewRoute,
  _authEventsEventIdRoute: _authEventsEventIdRoute,
  _authFundDistributionsFundDistributionIdRoute:
    _authFundDistributionsFundDistributionIdRoute,
  _authFundDistributionsNewRoute: _authFundDistributionsNewRoute,
  _authFundUnitOrdersIdRoute: _authFundUnitOrdersIdRoute,
  _authFxTradesFxTradeIdRoute: _authFxTradesFxTradeIdRoute,
  _authNotificationsNotificationIdRoute: _authNotificationsNotificationIdRoute,
  _authOnboardingRequestsNewRoute: _authOnboardingRequestsNewRoute,
  _authOrganisationsOrganisationIdRoute: _authOrganisationsOrganisationIdRoute,
  _authOrganisationsBalanceSummariesRoute:
    _authOrganisationsBalanceSummariesRoute,
  _authProductsProductIdRoute: _authProductsProductIdRouteWithChildren,
  _authScheduledFundMovementsScheduledFundMovementIdRoute:
    _authScheduledFundMovementsScheduledFundMovementIdRoute,
  _authSissAccountsTabRoute: _authSissAccountsTabRoute,
  _authStatementBatchesKindRoute: _authStatementBatchesKindRoute,
  _authStatementsStatementIdRoute: _authStatementsStatementIdRoute,
  _authTermDepositsNewRoute: _authTermDepositsNewRoute,
  _authTransactionImportFileImportIdRoute:
    _authTransactionImportFileImportIdRoute,
  _authTransactionsQueueTabRoute: _authTransactionsQueueTabRoute,
  _authTransactionsTransactionIdRoute: _authTransactionsTransactionIdRoute,
  _authTransactionsBatchImportRoute: _authTransactionsBatchImportRoute,
  _authTransactionsNewRoute: _authTransactionsNewRoute,
  _authTransferGroupsTransferGroupIdRoute:
    _authTransferGroupsTransferGroupIdRoute,
  _authTransfersTransferIdRoute: _authTransfersTransferIdRoute,
  _authTransfersNewRoute: _authTransfersNewRoute,
  _authYieldhubSyncFileIdRoute: _authYieldhubSyncFileIdRoute,
  _authAssetsAssetIdCreateDemoTransactionsRoute:
    _authAssetsAssetIdCreateDemoTransactionsRoute,
  _authEburyClientIdBeneficiariesRoute: _authEburyClientIdBeneficiariesRoute,
  _authEburyClientIdTradesRoute: _authEburyClientIdTradesRoute,
  _authLedgerAccountsAccountIdRoute:
    _authLedgerAccountsAccountIdRouteWithChildren,
  _authLedgerTransactionsTransactionIdRoute:
    _authLedgerTransactionsTransactionIdRouteWithChildren,
  _authLedgerTransactionsNewRoute: _authLedgerTransactionsNewRoute,
  _authOrganisationsOrganisationIdRulesRoute:
    _authOrganisationsOrganisationIdRulesRoute,
  _authProductsProductIdRateHistoryRoute:
    _authProductsProductIdRateHistoryRoute,
  _authStatementBatchesKindStatementBatchIdRoute:
    _authStatementBatchesKindStatementBatchIdRoute,
  _authTransactionMonitoringEvaluationsEvaluationIdRoute:
    _authTransactionMonitoringEvaluationsEvaluationIdRoute,
  _authTransactionMonitoringFindingsFindingIdRoute:
    _authTransactionMonitoringFindingsFindingIdRoute,
  _authCurrencycloudAccountIdBalancesBalanceIdRoute:
    _authCurrencycloudAccountIdBalancesBalanceIdRoute,
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute:
    _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdRoute,
  _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute:
    _authOrganisationsOrganisationIdBusinessEntitiesBusinessEntityIdMercuryOnboardingRoute,
}

const _authRouteWithChildren = _authRoute._addFileChildren(_authRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SignInRouteRoute: SignInRouteRouteWithChildren,
  _authRoute: _authRouteWithChildren,
  SignOutRoute: SignOutRoute,
  UserProfileChar123SuffixChar125Route: UserProfileChar123SuffixChar125Route,
  UserProfileIndexRoute: UserProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
